module.exports = {
  "action": {
    "search": "查詢",
    "search1": "查看",
    "creat": "新建",
    "creat1": "創建",
    "creat2": "新增",
    "renew": "更新",
    "renew1": "刷新",
    "recheck": "重新檢查",
    "import": "導入",
    "Importing": "導入中...",
    "export": "導出",
    "input": "請輸入",
    "improve": "請完善",
    "select": "請選擇",
    "select1": "選中",
    "write": "填寫",
    "whether": "是否",
    "edit": "編輯",
    "change": "修改",
    "copy": "複製",
    "modifiable": "可修改",
    "delete": "刪除",
    "delete1": "清除",
    "regain": "確認恢復嗎？",
    "stopusing": "確定停用嗎",
    "Enable": "啟用",
    "Deactivate": "停用",
    "expand": "展開",
    "fold": "收起",
    "photograph": "拍照",
    "login": "登錄",
    "login1": "用戶登錄",
    "logout": "退出登錄",
    "contract": "聯繫客服",
    "wxScan": "請用微信掃碼",
    "modifyPwd": "修改密碼",
    "confirm": "確定",
    "confirm1": "確認",
    "convertTo": "轉為",
    "return": "返回",
    "return1": "歸還",
    "return2": "已歸還",
    "noreturn": "未歸還",
    "noreturn1": "未完全歸還",
    "previousPage": "上一頁",
    "nextPage": "下一頁",
    "use": "使用",
    "add": "添加",
    "add1": "加入",
    "upload": "上傳",
    "save": "保存",
    "save1": "暫存",
    "cancel": "取消",
    "close": "關閉",
    "scan": "掃描",
    "scan1": "掃",
    "operate": "操作",
    "synchronous": "同步",
    "yes": "是",
    "no": "否",
    "have": "有",
    "nothing": "無",
    "deactivate": "停用",
    "restore": "恢復",
    "statistics": "統計",
    "gather": "採集",
    "applyfor": "申請",
    "newapplyfor": "新申請",
    "Notappliedfor": "未申請",
    "print": "打印",
    "need": "需要",
    "notNeed": "不需要",
    "automatic": "自動",
    "delayed": "延時",
    "describe": "描述",
    "association": "關聯",
    "independence": "無關",
    "remind": "提醒",
    "handle": "處理",
    "way": "方式",
    "calculate": "核算",
    "binding": "綁定",
    "unbind": "解綁",
    "binding1": "已綁定",
    "count": "計數",
    "Bold": "加粗",
    "disassemble": "拆卸",
    "examine": "審核",
    "record": "錄入",
    "record1": "記錄",
    "registration": "登記",
    "Collection": "下收",
    "sterilization": "滅菌",
    "disinfect": "消毒",
    "recycle": "回收",
    "recycle1": "可回收的",
    "Unrecycled": "未回收",
    "package": "包裝",
    "package1": "檢查包裝",
    "package2": "配包",
    "packagetwo": "打包",
    "package3": "已打包",
    "Tbpackaged": "待包裝(已清洗質檢)",
    "Secondinspection": "二檢",
    "Unpacked": "未打包",
    "clean": "清洗",
    "CleaningMachine": "清洗機",
    "Sterilizer": "滅菌器",
    "cleanquality": "清洗質檢",
    "biological": "生物監測",
    "check": "清點",
    "out": "發放",
    "receive": "接收",
    "Returnpackage": "還包",
    "borrow": "借包",
    "Backwash": "回洗",
    "Delivery": "送物",
    "Back": "回退",
    "urgent": "加急",
    "infect": "感染",
    "supply": "補充",
    "patch": "補",
    "more": "更多",
    "complete": "完成",
    "success": "成功",
    "fail": "失敗",
    "hand": "手動",
    "shield": "屏蔽",
    "maintenance": "維護",
    "Oneclick": "一鍵",
    "obtain": "獲取",
    "default": "默認",
    "display": "顯示",
    "Hidden": "隱藏",
    "Hidden1": "已隱藏",
    "Unhidden": "未隱藏",
    "repeatable": "重複",
    "Norepeatable": "不可重複",
    "caption": "說明",
    "fit": "設置",
    "manage": "管理",
    "Handover": "交接",
    "Patchwork": "補打",
    "searchfor": "搜索",
    "Centralized": "集採",
    "action": "操作",
    "reset": "重置",
    "take": "拍照"
  },
  "object": {
    "name": "名稱",
    "name1": "名",
    "name2": "類名",
    "userName": "用戶名",
    "people": "人員",
    "user": "用戶",
    "jobNumber": "工號",
    "code": "刻碼",
    "code1": "碼",
    "code2": "編碼",
    "Totalcode": "總碼",
    "pinyin": "拼音",
    "instrument": "器械",
    "instrumentset": "器械包",
    "set": "包",
    "information": "信息",
    "Implants": "植入物",
    "unImplants": "非植入物",
    "hospital": "醫院",
    "In": "院內",
    "Outside": "院外",
    "center": "處理中心",
    "center1": "院區",
    "cssd": "供應室",
    "department": "科室",
    "DepartmentGroup": "科室組",
    "supplier": "供應商",
    "container": "籃筐",
    "container1": "托盤",
    "disposables": "耗材",
    "Thispackage": "該包",
    "article": "物品",
    "type": "類型",
    "page": "頁面",
    "list": "清單",
    "table": "列表",
    "log": "日誌",
    "annex": "附件",
    "detail": "明細",
    "detail1": "明細小節",
    "longTerm": "長租",
    "shortTerm": "短租",
    "group": "分組",
    "password": "密碼",
    "tel": "電話",
    "email": "郵箱",
    "address": "地址",
    "brand": "品牌",
    "unitPrice": "單價",
    "number": "次數",
    "number1": "數量",
    "number2": "人數",
    "pieces": "件數",
    "remarks": "備註",
    "weight": "重量",
    "specifications": "規格",
    "model": "型號",
    "g": "克",
    "image": "照片",
    "image1": "圖片",
    "date": "日期",
    "time": "時間",
    "content": "內容",
    "file": "文件",
    "base": "基數",
    "base1": "基礎",
    "No": "暫無",
    "data": "數據",
    "whole": "全部",
    "all": "全選",
    "state": "狀態",
    "class": "類別",
    "inventory": "庫存",
    "location": "位置",
    "company": "公司",
    "tag": "標籤",
    "tag1": "標籤號",
    "trussUp": "捆綁",
    "day": "天",
    "day1": "天數",
    "individual": "個",
    "validity": "效期",
    "validity1": "有效期",
    "warning": "預警",
    "collocation": "組配",
    "collocation1": "配組",
    "processe": "工序",
    "property": "財產",
    "sort": "排序",
    "batch": "批次",
    "batch1": "批量",
    "document": "單據",
    "support": "技術支持",
    "ade": "不良事件",
    "ade1": "不良事件登記",
    "problem": "問題",
    "material": "材料",
    "template": "模板",
    "cost": "費",
    "cost1": "成本",
    "sum": "金額",
    "total": "總和",
    "total1": "總計",
    "sumtotal": "總數",
    "Thirdpartysystem": "第三方系統",
    "note": "注意事項",
    "other": "其他",
    "level": "級別",
    "demand": "需求",
    "tower": "台",
    "units": "台次",
    "Station": "台號",
    "Filteritems": "篩選項",
    "Potnumber": "鍋次",
    "Pot": "鍋號",
    "circulatingnurse": "巡迴護士",
    "scrubnurse": "洗手護士",
    "reason": "原因",
    "post": "崗位",
    "education": "學歷",
    "title": "職稱",
    "gender": "性別",
    "gender1": "男女",
    "equipment": "設備",
    "produce": "廠家",
    "produceTwo": "生產廠家",
    "delivery": "送貨人",
    "deliverytime": "送貨時間",
    "contactinformation": "聯繫方式",
    "patient": "病人",
    "outpatientservice": "門診",
    "moniker": "姓名",
    "male": "男",
    "female": "女",
    "Bednumber": "床號",
    "age": "年齡",
    "ward": "病區",
    "Chiefsurgeon": "主刀醫生",
    "operation": "手術",
    "Proposedimplementation": "擬施",
    "Powertools": "動力工具",
    "tool": "工具",
    "steelplate": "鋼板",
    "screw": "螺釘",
    "fullscreen": "全屏",
    "exit": "退出",
    "udi": "UDI",
    "rfid": "RFID",
    "duration": "工作時長",
    "language": "設置語言",
    "chinese": "簡體中文",
    "english": "英語",
    "triditionalCN": "繁體中文",
    "thai": "泰語",
    "loading": "加載中",
    "dictionaryName": "字典名稱",
    "dictionaryType": "字典類型",
    "dataLabel": "數據標簽",
    "dataKeyValue": "數據鍵值",
    "displaySorting": "顯示排序",
    "divtLable": "字典標簽"
  },
  "describe": {
    "basic": "基本",
    "please": "請",
    "wait": "稍後",
    "foreign": "外來",
    "daixiao": "代消",
    "dressing": "敷料",
    "or": "或",
    "and": "和",
    "do": "為",
    "Cannotbe": "不可為",
    "use": "以",
    "stop": "已",
    "selected": "已選",
    "belongTo": "歸屬",
    "affiliation": "所屬",
    "standard": "標準",
    "maximum": "最大",
    "regular": "固定",
    "special": "特殊",
    "prevail": "為準",
    "multiple": "多重",
    "settlement": "結算",
    "front": "前",
    "after": "後",
    "difference": "差異",
    "excessive": "多餘",
    "lack": "缺少",
    "must": "必須",
    "greaterthan": "大於",
    "lessthan": "小於",
    "empty": "空",
    "correct": "正確的",
    "nothave": "沒有",
    "right": "正常",
    "saveas": "另存為新包",
    "amountto": "合計",
    "choose": "按包名選擇回收",
    "ordinary": "普通",
    "documentation": "歸檔",
    "unmatched": "未匹配",
    "daily": "日常"
  },
  "prompt": {
    "notnull": "不能為空",
    "clickimg": "點擊查看大圖",
    "Existingproblems": "掃碼存在問題，請檢查輸入法的中英模式或大小寫",
    "Existed": "該包已經存在待回收列表中",
    "Unchecked": "不選默認是當天",
    "Unchecked1": "已經發送過敷料包，是否繼續",
    "notprint": "pda暫不支持打印",
    "ShowOnly": "只顯示使用最新記錄",
    "error": "獲取緩存數據出錯",
    "delete": "確認刪除嗎?",
    "convert": "確認轉為耗材嗎？",
    "enter": "輸入完成按Enter鍵添加",
    "saveduplicate": "存在已綁定的udi，請處理後重新檢查",
    "msg": "可添加udi的位置不足，繼續添加嗎？",
    "msg1": "-1 是默認值，不自動發放；",
    "msg2": "0 是自動發放且立即發放；",
    "msg3": ">0 是自動發放且延時發放的時間(單位：分鐘)",
    "msg4": "滅菌有效期規範化設置，通過包裝材料、處理方式、季節等進行自動判定；",
    "msg5": "並對相關設置添加說明；如需修改，必須給出修改的原因；",
    "msg6": "設置收費模式，並做出相關收費說明？",
    "msg7": "該物品已經存在列表中，請勿重複添加",
    "msg8": "該物品不存在系統中，是否新建",
    "msg9": "請填寫正確的還包數量",
    "msg10": "數量必須大於0",
    "msg11": "請掃描正確的碼",
    "msg12": "請掃描籃筐碼",
    "msg13": "請選擇需要預處理的物品",
    "msg14": "請選擇需要分類的器械包",
    "msg15": "請選擇退回物品",
    "msg16": "至少保留一條籃筐數據",
    "msg17": "請掃描預處理人",
    "msg18": "該人員碼不存在",
    "msg19": "請選擇物品",
    "msg20": "確認刪除嗎？",
    "msg21": "必須選擇補錄原因!",
    "msg22": "該籃筐不在列表",
    "msg23": "掃描或選擇清洗程序",
    "msg24": "其中有包不支持當前清洗方式，是否繼續",
    "msg25": "其中有包不支持當前清洗方式，請調整清洗方式或物品",
    "msg26": "請選擇清洗方式",
    "msg27": "請掃描清洗機程序碼",
    "msg28": "請選擇開始清洗的人員和清洗程序",
    "msg29": "請掃描或選擇清洗機",
    "msg30": "請掃描或選擇清洗程序",
    "msg31": "重新清洗成功",
    "msg32": "開始運行成功",
    "msg33": "清洗成功",
    "msg34": "清洗補錄時間比當前物品回收的時間還早",
    "msg35": "請確認是否繼續",
    "msg36": "當前已選擇籃筐",
    "msg37": "該設備未完成登記，請完成後運行操作",
    "msg38": "清洗設備外表面潔淨與否",
    "msg39": "清洗設備顯示屏",
    "msg40": "清洗設備打印紙",
    "msg41": "清洗設備門膠條清潔與否",
    "msg42": "水電氣故障與否",
    "msg43": "清洗設備管道通暢",
    "msg44": "酶油量是否充足",
    "msg45": "純化水電導率（≤15us/cm2）",
    "msg46": "清洗設備艙體潔淨與否",
    "msg47": "清洗設備過濾網清潔",
    "msg48": "噴淋臂能否自由旋轉",
    "msg49": "噴淋臂噴嘴有無阻塞",
    "msg50": "清洗設備清洗架清潔",
    "msg51": "請將表單填寫完整",
    "msg52": "登記完成",
    "msg53": "請掃描需要下架的包",
    "msg54": "請選擇滅菌器和滅菌架",
    "msg55": "請掃描滅菌員",
    "msg56": "該滅菌器沒有進行測漏合格測試，是否繼續操作？",
    "msg57": "該人員不是滅菌員",
    "msg58": "請選擇滅菌器及程序",
    "msg59": "該設備程序規定每天每次需要做生物監測，是否繼續",
    "msg60": "該設備程序規定每天首次需要做生物監測，是否繼續",
    "msg61": "該滅菌器沒有進行測漏合格測試，無法繼續操作",
    "msg62": "該滅菌器沒有進行BD合格測試，無法繼續操作",
    "msg63": "該滅菌器沒有進行BD測試，是否繼續操作？",
    "msg64": "請掃描滅菌器程序碼",
    "msg65": "請選擇開始滅菌的人員和滅菌程序",
    "msg66": "請選擇滅菌器",
    "msg67": "請選擇待滅菌物品",
    "msg68": "所選物品未到滅菌時間，不可補錄",
    "msg69": "請填寫刪除原因",
    "msg70": "請掃滅菌架",
    "msg71": "請先選擇滅菌器",
    "msg72": "請選擇需要標記的包",
    "msg73": "請標記需要生物監測的包後再開始滅菌",
    "msg74": "請選擇生物監測原因",
    "msg75": "存在處理方式不相同的包，不能開始滅菌",
    "msg76": "列表中存在處理方式不相同的包，是否繼續？",
    "msg77": "確定下架嗎？",
    "msg78": "請掃描包碼",
    "msg79": "確定刪除嗎？",
    "msg80": "上傳成功",
    "msg81": "滅菌設備外表面潔淨與否",
    "msg82": "滅菌設備艙體潔淨與否",
    "msg83": "滅菌設備門膠條潔淨與否",
    "msg84": "滅菌設備顯示屏",
    "msg85": "滅菌設備打印紙",
    "msg86": "安全閥在校驗期內",
    "msg87": "壓力表在校驗期內",
    "msg88": "請選擇不合格原因",
    "msg89": "請選擇檢查方法",
    "msg90": "未找到清洗記錄",
    "msg91": "未找到對應的清洗記錄",
    "msg92": "上傳圖片成功",
    "msg93": "刪除圖片成功",
    "msg94": "確認結束清洗嗎？",
    "msg95": "清洗結束",
    "msg96": "還未清洗完成，不能合格",
    "msg97": "掃描清洗質檢人",
    "msg98": "清洗質檢成功",
    "msg99": "請選擇需要清洗質檢物品",
    "msga1": "會退回至待分類",
    "msga2": "清洗不合格原因",
    "msga3": "請選擇原因",
    "msga4": "滅菌質量抽查結果統計",
    "msga5": "滅菌物品質量監測",
    "msga6": "點擊圖片放大",
    "msga7": "生物培養管異常",
    "msga8": "請掃描第二質檢人",
    "msga9": "請掃描生物質檢人",
    "msga10": "請掃描抽查人",
    "msga11": "包外是否潮濕",
    "msga12": "包外是否有水霧或珠",
    "msga13": "器械清潔度",
    "msga14": "確認結束滅菌嗎？",
    "msga15": "請上傳質檢合格圖片",
    "msga16": "滅菌質檢成功",
    "msga17": "掃描生物質檢人",
    "msga18": "掃描生物質檢人並選擇不合格原因",
    "msga19": "該掃描生物質檢人",
    "msge20": "質檢人不能相同",
    "msga21": "生物監測成功",
    "msga22": "滅菌不合格原因",
    "msga23": "確認提前放行嗎？",
    "msga24": "請輸入包碼",
    "msga25": "查詢成功",
    "msga26": "請輸入正確的包碼",
    "msga27": "請填寫包碼",
    "msga28": "請選擇擺放層",
    "msga29": "請選擇擺放位置",
    "msga30": "請選擇擺放方式",
    "msga31": "請選擇抽查結果",
    "msga32": "會退回至待滅菌，確定繼續嗎？",
    "msga33": "提前放行信息",
    "msga34": "掃描滅菌質檢人",
    "msga35": "請掃描人員",
    "msga36": "滅菌質量抽查結果統計",
    "msga37": "列表信息有更新，請刷新列表",
    "msga38": "請選擇發放科室",
    "msga39": "發放物品為空",
    "msga40": "發放成功",
    "msga41": "請選擇需要打印的數據",
    "msga42": "本人已掃碼總數",
    "msga43": "輸入後回車代替掃碼",
    "msga44": "查看加急器械包",
    "msga45": "查看發放記錄",
    "msga46": "批量取消發放",
    "msga47": "待發放計劃打印",
    "msga48": "當前查詢結果包數過多，不能合併表格顯示，是否繼續",
    "msga49": "是否確認要移除包碼",
    "msga50": "不在當前發放計劃中",
    "msga51": "請插入CA來識別審核人",
    "msga52": "請選擇證書",
    "msga53": "已取消發放",
    "msga54": "請選擇自動檢庫計劃",
    "msga55": "庫存不足",
    "msga56": "當前列表中沒有加急器械包",
    "msga57": "沒有可取消發放的計劃",
    "msga58": "會將當前勾選並沒用包碼的行取消發放計劃，是否繼續",
    "msga59": "有加急器械包等待發放！",
    "msga60": "請掃描發放人",
    "msga61": "請填寫或掃描下送人",
    "msga62": "是否精確查找",
    "msga63": "全部外來器械",
    "msga64": "過期物品清庫記錄",
    "msga65": "不合格登記記錄",
    "msga66": "供應室包計數",
    "msga67": "發放不合格登記",
    "msga68": "過期物品清庫",
    "msga69": "科室退庫",
    "msga70": "該包已存在",
    "msga71": "發放科室選擇為手術室，禁止物品出庫",
    "msga72": "請選擇問題登記類型",
    "msga73": "請輸入包碼並回車",
    "msga74": "回收發放對照",
    "msga75": "器械包數量合計",
    "msga76": "請輸入接收人！",
    "msga77": "該批次所有的包將接收入庫",
    "msga78": "掃描審核的包將接收入庫",
    "msga79": "請輸入接收人",
    "msga80": "沒有可接收的包",
    "mage81": "未能識別的碼",
    "mage82": "該包尚未掃碼",
    "mage83": "當前列表不能為空",
    "msga84": "請輸入包碼或發放碼，然後回車",
    "msga85": "接收人不可為空",
    "msga86": "已經將重複的包進行了過濾",
    "msga87": "選擇退回原因",
    "msga88": "請選擇退庫原因",
    "msga89": "請選擇退庫器械包",
    "msga90": "選擇轉讓手術間",
    "msga91": "請從下面科室中選擇一個進行保存，取消將以",
    "msga92": "進行保存。",
    "msga93": "登記人不能為空",
    "msga94": "病人碼不能為空",
    "msga95": "手術時間不能為空",
    "msga96": "分配時間",
    "msga97": "病人姓名不能為空",
    "msga98": "該包已被緩存, 禁止再次登記",
    "msga99": "該包已被緩存，是否再次登記進行覆蓋?",
    "msgb1": "該包已有其他病人信息登記，是否再次登記進行覆蓋?",
    "msgb2": "手術時間被調整為當前時間",
    "msgb3": "請掃描或輸入",
    "msgb4": "請完善必填信息",
    "msgb5": "請選擇科室後保存",
    "msgb6": "外來器械病人信息不符，請注意確認",
    "msgb7": "外來器械病人信息不符",
    "msgb8": "的滅菌時間比手術時間晚，禁止登記",
    "msgb9": "請選擇手術間",
    "msgb10": "轉讓成功",
    "msgb11": "退庫成功",
    "msgb12": "請選擇退庫物品",
    "msgb13": "確認保存嗎？",
    "msgb14": "禁止提交申請",
    "msgb15": "強制按選擇的處理中心申請",
    "msgb16": "沒有可複制的包",
    "msgb17": "是否確定撤銷？",
    "msgb18": "當前選擇的不是默認申請供應室, 是否進行切換?",
    "msgb19": "該包已存在列表中",
    "msgb20": "未找到該推車碼",
    "msgb21": "將會覆蓋當前列表，確定繼續嗎？",
    "msgb22": "模版內沒有可用的包",
    "msgb23": "當前列表中存在重複的數據，需要合併嗎？",
    "msgb24": "該包無法申請或已被申請",
    "msgb25": "系統會將申請全部發送給",
    "msgb26": "列表中存在重複的數據，需要合併嗎？",
    "msgb27": "申請人不可為空",
    "msgb28": "申請列表不可為空",
    "msgb29": "批次不可為空",
    "msgb30": "請選擇需要提交的包",
    "msgb31": "系統會根據所屬處理中心將申請分別給不同供應室，是否繼續?",
    "msgb32": "請插入CA來識別審核人",
    "msgb33": "請先進行申請單打印配置（字典248）",
    "msgb34": "請勾選要加急的物品",
    "msgb35": "請選擇器械包",
    "msgb36": "請勾選要刪除的器械包",
    "msgb37": "是否確定刪除？",
    "msgb38": "科室借包記錄",
    "msgb39": "已使用包記錄",
    "msgb40": "請選擇要添加的包",
    "msgb41": "沒有可添加的包",
    "msgb42": "發放申請記錄",
    "msgb43": "申請發放不一致",
    "msgb44": "列表中當前列表中存在重複的數據，需要合併嗎？",
    "msgb45": "確認取消嗎?",
    "msgb46": "是否將該病人的所有包解除使用綁定？",
    "msgb47": "質控問題登記",
    "msgb48": "器械清洗不合格",
    "msgb49": "器械完整性不合格",
    "msgb55": "該包沒有器械無法登記",
    "msgb58": "無菌物品發放不合格登記",
    "msgb60": "請選擇設備後再操作",
    "msgb61": "請選擇滅菌日期後再操作",
    "successfullyAdded": "補錄成功",
    "isSureToReturn": "是否確定退回",
    "prompt": "該包是無碼器械包可直接回收",
    "promptone": "存在包的數量大於",
    "prompttwo": "確認完成清點嗎？",
    "promptthree": "請選擇完成清點的器械包",
    "prompt1": "掃碼存在問題，請檢查輸入法的中英模式或大小寫。",
    "prompt2": "獲取包信息失敗",
    "prompt3": "請先掃描器械udi或標記問題",
    "prompt4": "缺少回收信息, 請重新掃碼添加",
    "prompt5": "未識別的包碼",
    "prompt6": "請先勾選包",
    "prompt7": "請選擇要回收的包",
    "prompt8": "名稱或規格不可重複",
    "prompt9": "該碼中的包都已經存在，是否繼續添加？",
    "prompt10": "廠家不在效期內",
    "error1": "請先選擇廠家",
    "error2": "請配置字典372，否則外來器械名稱將無法顯示",
    "error3": "請填寫器械包名稱",
    "error4": "請正確填寫數量",
    "error5": "該包不允許包裝",
    "deleted": "刪除成功",
    "deactivated": "停用成功",
    "Import": "導入成功",
    "deactivat": "確認停用嗎？",
    "required": "請填寫必填項",
    "permissions": "請選擇權限",
    "Successfullymodified": "修改成功",
    "Successfullyadded": "新增成功",
    "Operationsuccessful": "操作成功",
    "Pleashospitalarea": "請填寫院區名稱",
    "switchdevice": "確認轉為器械嗎？",
    "Successfullydevice": "轉為器械成功",
    "Successfullyconsumables": "轉為耗材成功",
    "devicename": "請輸入器械",
    "duplicated": "規格型號不能重複",
    "UDIinformation": "請完善UDI信息",
    "greaterthan": "器械件數要大於0",
    "packagename": "請先輸入器械包",
    "enterconsumables": "請輸入耗材",
    "basicunit": "請填寫基本單位",
    "programname": "請填寫程序名稱",
    "Onlydefault": "只能設置一個默認程序",
    "informationfirst": "請先保存基本信息",
    "Successfullysaved": "保存成功",
    "Errorlabel": "標籤內容解析出錯",
    "Contentempty": "內容為空",
    "conversionerror": "標籤內容轉換出錯",
    "Pleasehospitaldepartment": "請選擇醫院/科室",
    "addconsumptionpackage": "請添加代消包",
    "Addedsuccessfully": "添加成功",
    "selecthospitalfirst": "請先選擇院區",
    "Norecyclableitems": "沒有可回收的物品",
    "packagenormal": "該包正常",
    "notapplied": "該包科室未申請",
    "entercode": "請輸入正確的碼",
    "selectbatch": "請選擇批次",
    "Inventorycompleted": "已完成清點",
    "Allcleared": "已全部清除",
    "updatesuccess": "更新成功",
    "Registrationsuccessful": "登記成功",
    "recycleditemsempty": "回收物品列表為空",
    "selectdepartment": "請選擇科室",
    "Pleaseadd": "請輸入想加入的文本",
    "Pleaseenter": "請輸入想搜索的屬性",
    "Pleaseimage": "請選擇圖片",
    "Nocamera": "沒有開啟攝像頭權限或瀏覽器版本不兼容",
    "takephotofirst": "請先拍照",
    "selectfile": "請選擇文件",
    "supportedtypes": "請選擇文件並上傳，支持的類型為",
    "handoversupplyroom": "請選擇交接供應室",
    "continueprinting": "該標籤已打印，是否繼續打印",
    "Pleasereplacement": "請選擇補打原因",
    "GeneratingQRcode": "生成二維碼中",
    "Personnelduplicated": "人員不能重複",
    "Pleasepotnumber": "請填寫鍋號和鍋次",
    "Pleasepackagecode": "請輸入包碼",
    "Pleaseselectdata": "請選擇數據",
    "rollback": "確定回退嗎？",
    "Fallbacksuccessful": "回退成功",
    "Packageonly": "包只能添加一次",
    "cacheablepackages": "沒有可緩存的包",
    "Pleasenumber": "請選擇標籤號",
    "Pleasepackagingperson": "請掃描包裝人",
    "Pleasereviewer": "請掃描審核人",
    "recoverysuccessful": "恢復成功",
    "Personnelnotexist": "人員不存在",
    "Pleasewait": "該包暫不能組配，請稍後",
    "Queryinformationframe": "查詢時間範圍內，完成回收清點的器械包信息和數量",
    "Queryinformationframe1": "查詢時間範圍內，按回收科室統計，完成回收清點的器械包總量",
    "Queryinformationframe2": "查詢時間範圍內，執行並完成清洗流程的清洗設備的運行信息和參數，以及處理的器械包信息",
    "Queryinformationframe3": "查詢時間範圍內，執行並完成滅菌流程的滅菌設備的運行信息和參數，以及處理的器械包",
    "Queryinformationframe4": "查詢時間範圍內，完成發放的器械包信息和數量",
    "Queryinformationframe5": "查詢時間範圍內，按發放科室統計，完成發放的器械包總量",
    "Queryinformationframe6": "以自然月為單位，按發放科室統計，供應中心完成CSSD流程處理的不同包裝規格的器械",
    "Queryinformationframe7": "以自然年為單位，按發放科室統計，供應中心完成CSSD流程處理的器械包總量和處理費用總金額",
    "NumberExceed": "超出數量限制",
    "packagereturn": "該包已有科室接受記錄，是否將包退回？",
    "secondIssueRightMsg1": "存在已掃碼數量未達標的數據，疑似少發，是否繼續",
    "secondIssueRightMsg2": "未達到實際回收的數量，請檢查掃碼後再重試",
    "secondIssueRightMsg3": "未達到發放申請的數量，請檢查掃碼後再重試",
    "secondIssueRightMsg4": "未達到包裝批次的數量，請檢查掃碼後再重試",
    "secondIssueRightMsg5": "請選擇滅菌器和日期後選擇鍋次"
  },
  "common": {
    "drag": "將文件拖到此處",
    "download": "下載模板",
    "full": "全",
    "lifetime": "可使用次數",
    "action": "操作",
    "list": "列表",
    "longTerm": "長租",
    "shortTerm": "短租",
    "loangear": "外來器械",
    "disable": "禁用",
    "enable": "啟用",
    "baseOn": "以",
    "applicationform": "發放申請為準",
    "bundle": "捆綁",
    "postponed": "延時",
    "expirydate": "效期",
    "accounting": "核算",
    "detail": "內容",
    "countable": "計數",
    "section": "明細",
    "include": "是否有",
    "before": "前",
    "after": "後",
    "employee": "人員",
    "sterilizer": "滅菌器",
    "ID": "ID",
    "startdate": "開始日期",
    "enddate": "結束日期",
    "form": "清單",
    "cache": "暫存",
    "completed": "完成",
    "approver": "審核人",
    "limmit": "限制",
    "empty": "清空",
    "if": "是否",
    "to": "至",
    "ItemSummary": "物品匯總",
    "selected": "選中",
    "Later": "稍後",
    "retrace": "追溯",
    "procedure": "Procedure",
    "result": "結果",
    "Qualityinspector": "質檢人",
    "Secondqualityinspector": "第二質檢人",
    "Accuratesearch": "精確查找",
    "Pipelinenode": "流水線節點",
    "Earlyrelease": "提前放行",
    "Selfuse": "自用",
    "expire": "過期",
    "location": "使用地點",
    "washer": "清洗設備",
    "program": "程序",
    "msg": "請選擇需要交接的包",
    "msg1": "沒有可打印的數據",
    "msg2": "無菌庫有",
    "msg3": "件包過期，是否立刻處理？",
    "msg4": "請選擇需要導出的物品",
    "msg5": "請選擇需要發放的物品",
    "msg6": "查詢流程時間範圍交集內，器械包的處理流程信息",
    "msg7": "請完善信息",
    "msg8": "請選擇已有的包",
    "msg9": "沒有可打印的包",
    "msg10": "您有未掃碼的器械，是否繼續？",
    "msg11": "確認清除嗎？"
  },
  "recycle": {
    "input": " Input",
    "id": "ID",
    "current": "清點",
    "statisList": "新增器械包統計",
    "approved": "審核",
    "Returnpackage": "還包",
    "loan": "外來器械",
    "daixiao": "代消",
    "rec": "回收",
    "applyVariance": "申請差異記錄",
    "infect": "感染",
    "urgent": "加急",
    "level": "級別",
    "small_infect": "感染",
    "summary": "統計",
    "from": "开始时间",
    "to": "结束时间",
    "quantity": "數量",
    "recycled": "已回收",
    "borrowed": "借包",
    "info": "Info.",
    "srg": "手術",
    "right": "正常",
    "inventory": "庫存",
    "before": "前",
    "after": "後",
    "qty": "拆卸",
    "process": "流程",
    "operator": "清點人",
    "used": "使用"
  },
  "empty": {
    "moniker": "姓名不能為空",
    "account": "登錄賬號不能為空",
    "password": "密碼不能為空",
    "jobNumber": "工號不能為空",
    "department": "科室不能為空",
    "scopework": "工作範圍不能為空",
    "post": "崗位不能為空",
    "types": "類型不能為空",
    "Courtyard": "院區不能為空",
    "DepartmentGroup": "科室組不能為空",
    "center": "處理中心不能為空",
    "head": "負責人不能為空",
    "number": "賬號不能為空",
    "Device": "名稱不能為空",
    "Standard": "標準名稱不能為空",
    "consumable": "耗材名稱不能為空",
    "packageempty": "器械包不能為空",
    "returntimeempty": "還包時間不能為空",
    "Recyclerempty": "回收人不能為空",
    "Countingempty": "清點人不能為空",
    "Manufacturerempty": "廠家不能為空",
    "Supplierempty": "供應商不能為空",
    "surgicadepartmentempty": "手術科室不能為空",
    "deliverempty": "送貨人不能為空",
    "Wardempty": "病區不能為空",
    "replacementpersonempty": "補打人不能為空",
    "Sterilizerempty": "滅菌人不能為空",
    "packagingpersonempty": "包裝人或組配人不能為空",
    "Reviewerblank": "審核人不能為空",
    "cannotbeempty": "包裝材料、滅菌方式和效期都不能為空",
    "departmentamountexportbeempty": "科室金額導出時間不能為空",
    "questiontypeempty": "問題類型不能為空",
    "Partcannotempty": "部位不能為空"
  },
  "all": {
    "account": "登錄賬號",
    "nodata": "暫無數據",
    "personnel": "人員管理",
    "Pinformation": "人員信息",
    "authority": "權限",
    "PersonalData": "個人信息",
    "certificate": "證書",
    "Userlogin": "用戶登錄信息",
    "scopework": "工作範圍",
    "Accountstatus": "賬號狀態",
    "Endoscopic": "內鏡工號",
    "role": "角色",
    "Menupermissions": "菜單權限",
    "Buttonpermissions": "按鈕權限",
    "Setavatar": "設置頭像",
    "Basicinformation": "基本信息",
    "IDcard": "身份證",
    "nation": "民族",
    "Politicaloutlook": "政治面貌",
    "datebirth": "出生日期",
    "Hobbies": "愛好特長",
    "WorkInformation": "工作信息",
    "position": "職位",
    "Nurselevel": "護士能級",
    "entrytime": "入職時間",
    "Timeresignation": "離職時間",
    "mobilephone": "手機",
    "Homephone": "家庭電話",
    "emergencycontact": "緊急聯繫人",
    "Emergencycall": "緊急電話",
    "email": "郵箱",
    "address": "地址",
    "filename": "文件名",
    "blank": "空白",
    "AddCenter": "添加處理中心",
    "AddCampus": "添加院區",
    "Synchronizedata": "同步數據",
    "Newgroup": "新建科室組",
    "Parentdepartment": "父級科室",
    "head": "負責人",
    "Expiration": "無菌庫過期小時數",
    "floor": "樓層",
    "Unrestricted": "不限制申請",
    "registeruse": "是否需要做使用登記",
    "Blockexpiredpackages": "屏蔽過期包",
    "HISDepartment": "HIS系統科室",
    "HIScode": "HIS系統科室代碼",
    "MaterialDepartment": "物資系統科室",
    "Materialcode": "物資系統科室代碼",
    "DistributionPlan": "發放計劃",
    "packagingbatch": "按包裝批次",
    "distributionapplication": "按發放申請",
    "vehicle": "下送車",
    "zhanghao": "賬號",
    "departmentmanagement": "科室管理",
    "Newdepartment": "新建科室",
    "EditingDepartment": "編輯科室",
    "Editdepartmentgroup": "編輯科室組",
    "ConsumableManagement": "耗材管理",
    "Allconsumables": "全部耗材",
    "DeviceManagement": "器械管理",
    "fullname": "全名稱",
    "Devicebound": "已綁定器械",
    "Packagingmethod": "包裝方式",
    "Handlingmethod": "處理方式",
    "InventoryLocation": "庫存位置",
    "Importcardinality": "導入基數",
    "ExportManifest": "導出清單",
    "Exportengravingpackage": "導出刻碼包",
    "PageEditing": "頁面編輯",
    "Devicepackagemanagement": "器械包管理",
    "Inventorypackagestatistics": "庫存包統計",
    "Isdevice": "是否外來器械",
    "corporatename": "公司名稱",
    "FixedDetails": "是否固定明細",
    "Centralizednot": "是否集採",
    "Specialitems": "特殊物品",
    "labelprinting": "標籤打印",
    "Bundledprinting": "捆綁打印",
    "distributiondelay": "自動發放延時",
    "distri": "以發放申請為準",
    "Numberimplants": "植入物數量",
    "Automaticallyperiod": "自動關聯效期",
    "Sterilizationvalidity": "滅菌有效期",
    "Disinfectionvalidity": "消毒有效期",
    "Multiplesterilization": "多重滅菌",
    "cleaningmethod": "清洗方式",
    "Sterilizationfee": "滅菌費",
    "Otherfee": "其他費用",
    "Cleaningfee": "清洗費",
    "packagingfee": "檢查包裝費",
    "Distributionfee": "發放費",
    "costamount": "成本金額",
    "settlement": "結算金額",
    "newapplyfor": "新申請費",
    "AlertInventory": "預警庫存",
    "Numberdevices": "器械件數",
    "Numberconsumables": "耗材件數",
    "Numbercomponents": "配組件數",
    "Locationencoding": "位置編碼",
    "PropertyOwnership": "財產歸屬科室",
    "Costaccounting": "成本核算類型",
    "foreignpackage": "外來器械包類名",
    "Packagingprecautions": "配包注意事項",
    "Recyclingprecautions": "回收注意事項",
    "Cleaningprecautions": "清洗注意事項",
    "Sterilizationprecautions": "滅菌注意事項",
    "Distributionprecautions": "發放注意事項",
    "Packageengravingcode": "包刻碼",
    "Creationtime": "創建時間",
    "Automaticupdate": "自動更新",
    "Beforedisassembly": "拆卸前",
    "Afterdisassembly": "拆卸後",
    "otherImplants": "其他植入物",
    "nootherImplants": "其他非植入物",
    "Details": "固定明細",
    "DeviceDetails": "器械明細",
    "ConsumableDetails": "耗材明細",
    "Recycler": "回收人",
    "PackagingSpecifications": "包裝規格",
    "ExternalDeviceType": "外來器械類型",
    "TotalEquipmentPackage": "器械包總計",
    "ItemsToBeClassified": "待分類物品",
    "BatchDeletion": "批量刪除",
    "BatchSupplementaryRecording": "批量補錄",
    "HandoverOfItems": "物品交接",
    "BatchReturn": "批量退回",
    "BasketCode": "籃筐碼",
    "BatchSelection": "批量選中",
    "CourtyardHandover": "院區交接",
    "Retreat": "退",
    "ThereAreDeviceIssues": "存在器械問題",
    "SupplementaryRecording": "補錄",
    "return3": "退回",
    "BatchPreprocessing": "批量預處理",
    "CleaningPreTreatmentPersonnel": "清洗預處理人",
    "ScanPersonnelCode": "掃描人員碼",
    "Preprocessing": "預處理",
    "DateFiltering": "日期篩選",
    "DevicePackageName": "器械包名稱",
    "Preprocessor": "預處理人",
    "TotalNumberOfItems": "物品總數",
    "Confirm": "確定",
    "FinishedSortingItems": "已分類完成物品",
    "PreprocessingMethod": "預處理方式",
    "ShortTermRentalOfForeignEquipment": "短租外來器械",
    "LongTermRentalOfExternalEquipment": "長租外來器械",
    "number": "編號",
    "Distributors": "經銷廠家",
    "Numberalerts": "預警數量",
    "Basicunit": "基本單位",
    "Units": "單位換算",
    "equipmentmanagement": "設備管理",
    "price": "價格",
    "Life": "使用年限",
    "Sterilizationmethod": "滅菌方式",
    "Biologicaltime": "生物檢測時間",
    "contacts": "聯繫人",
    "Telephone": "聯繫電話",
    "mobile": "移動電話",
    "Firstusetime": "初次使用時間",
    "Equipmentperson": "設備責任人",
    "Departmentperson": "科室責任人",
    "Specificationmodel": "規格型號",
    "Qualityequipmenttype": "質控設備類型",
    "Qualitysterilizationtype": "質控滅菌類型",
    "operatingcost": "運行費用",
    "yuan": "元",
    "zeroclearing": "鍋次每天清零",
    "prohibit": "滅菌器禁止不同滅菌方式的包",
    "Biologicalrequired": "每鍋需要做生物監測",
    "Runprinting": "運行打印",
    "Endcalibration": "結束校準",
    "duration": "時長",
    "BD": "BD",
    "leakhunting": "測漏",
    "Emptyoperation": "空鍋運行",
    "Sideinspectiontime": "側漏程序檢驗時間",
    "Defaultbiological": "默認生物監測",
    "Biologicalfrequency": "生物監測頻率",
    "shelvingdata": "強制空鍋並保留原有上架數據",
    "first": "首次",
    "everytime": "每次",
    "ReasonForSupplementaryRecording": "補錄原因",
    "ItemsToBeCleanedAndDisinfected": "待清洗消毒物品",
    "BlueBasketName": "藍筐名稱",
    "stepByStepCleaning": "分步清洗",
    "integratedMachineCleaning": "一體機清洗",
    "utensils": "器皿",
    "cleaningMachineOperationStatus": "清洗機運行情況",
    "equipmentRegistrationRecords": "設備登記記錄",
    "itemName": "物品名稱",
    "reCleaning": "重新清洗",
    "startCleaning": "開始清洗",
    "disinfectionMethod": "消毒方式",
    "dryingMethod": "乾燥方式",
    "cleaningPersonnel": "清洗人",
    "pleaseScanTheCleaner": "請掃描清洗人",
    "pleaseScanTheCleaningRack": "請掃描清洗架",
    "cleaningRack": "清洗架",
    "cleaningProgram": "清洗程序",
    "whetherToManuallyFillThePot": "手填鍋次",
    "cleaningPotTimes": "清洗鍋次",
    "Loadingequipment": "裝載用具",
    "Loadingtoolmanagement": "裝載用具管理",
    "Warehouse": "所屬庫房",
    "Batchprint": "批量打印",
    "repeatScan": "重複掃描",
    "tagname": "標籤名稱",
    "test": "測試",
    "prompt": "提示",
    "goRegister": "去登記",
    "registrationOfCleaningEquipment": "清洗設備登記",
    "sterilizationEquipmentName1": "滅菌設備名稱1",
    "clean1": "潔淨",
    "noClean1": "不潔淨",
    "abnormal": "不正常",
    "adequate": "充足",
    "insufficient": "不充足",
    "fault": "故障",
    "noFaults": "無故障",
    "unobstructed": "通暢",
    "notUnobstructed": "不通暢",
    "PHValue": "PH值",
    "enzymeAdditionAmount": "加酶量（ml）",
    "addLubricatingOil": "加潤滑油（ml）",
    "purifiedWaterPressure": "純化水壓力（0.3Mpa）",
    "compressedAir": "壓縮空氣（0.4-0.6MPa）",
    "salt": "鹽(公斤)",
    "can": "能",
    "cannot": "不能",
    "block": "阻塞",
    "noBlocking": "無阻塞",
    "Preview": "預覽",
    "Totalpackages": "總包數",
    "equipmentMaintenanceRecords": "設備維護記錄",
    "registrationTime": "登記時間",
    "registrationArea": "登記區域",
    "deviceName": "設備名稱",
    "itemsToBeSterilized": "待滅菌物品",
    "addCurrentSterilizer": "加入當前滅菌器",
    "packagingDate": "包裝日期",
    "sterilizationDate": "滅菌日期",
    "packageCode": "包碼",
    "registrationOfUnqualifiedPackaging": "包裝不合格登記",
    "registrationOfDeviceIssues": "器械問題登記",
    "sterilizationAndShelving": "滅菌及上架",
    "selectSterilizerAndSterilizationRack": "選擇滅菌器及滅菌架",
    "sterilizerStatus": "滅菌器狀態",
    "overallCodeListing": "總碼上架",
    "totalCodeRemoval": "總碼下架",
    "biologicalMonitoringTime": "生物監測時間",
    "biologicalMonitoringReasons": "生物監測原因",
    "currentSterilizer": "當前滅菌器",
    "currentSterilizationRack": "當前滅菌架",
    "loaded": "已裝載",
    "packages": "個包",
    "departmentName": "科室名稱",
    "groupName": "分組名稱",
    "preservationOfBiologicalMonitoringMarkers": "生物監測標記保存",
    "startSterilization": "開始滅菌",
    "inputCorrection": "輸入更正",
    "importOtherSterilizers": "導入其他滅菌器",
    "abnormalDeviceIssues": "設備異常問題",
    "packetCount": "包計數",
    "sterilizationRack": "滅菌架",
    "pleaseScanTheSterilizationRack": "請掃描滅菌架",
    "sterilizationProcedure": "滅菌程序",
    "currentlyNoProgram": "暫無程序",
    "sterilizationPotNumber": "滅菌鍋次",
    "sign": "標記",
    "testPackageCode": "測試包碼",
    "reasonForDeletion": "刪除原因",
    "uploadAttachments": "上傳附件",
    "Packagestatistics": "包統計",
    "Recyclingrecords": "回收審核記錄",
    "ReturnRecord": "還包記錄",
    "Outsourcingpackage": "代消包",
    "Allinstrumentpacks": "全部器械包",
    "Usingunrecycled": "使用未回收器械",
    "Pleasecode": "請掃描人員碼",
    "Receiver": "下收人",
    "Printdocuments": "打印回收單據",
    "Urgentlevel": "加急級別",
    "Infectiontype": "感染類型",
    "Unreturnedquantity": "未歸還數量",
    "Supplementaryaddition": "補充新增",
    "Registrationissues": "器械問題登記",
    "usageinformation": "使用信息",
    "Completeinventory": "完成清點",
    "clearall": "全部清除",
    "Excesspieces": "多餘器械和件數",
    "Lackquantity": "缺少器械和件數",
    "Returntime": "歸還時間",
    "Returnquantity": "歸還數量",
    "borrowedpackages": "借包數量",
    "Distributiontime": "發放時間",
    "Issuedby": "發放人",
    "recipient": "接收人",
    "Returnregistration": "還包登記",
    "Returntime1": "還包時間",
    "Returnquantity1": "還包數量",
    "Proxyreception": "代消包接收",
    "packaging": "包裝材料",
    "Addrecyclinglist": "加入回收列表",
    "Manualrecycling": "手動回收物品",
    "Recyclingtemplates": "回收模板",
    "Blockdepartments": "屏蔽無關科室",
    "RecyclingDepartment": "回收科室",
    "Binddepartments": "綁定科室",
    "Basicmaintenance": "基礎數據維護",
    "warn": "警告",
    "DateTime": "日期時間",
    "Auditcode": "審核碼",
    "operationroom": "手術間",
    "Recyclingstatus": "回收狀態",
    "hiddenstate": "隱藏狀態",
    "Packagingstatus": "打包狀態",
    "Applicationdepartment": "申請科室",
    "time": "申請時間",
    "ApplicationNotes": "申請備註",
    "Quantity": "申請數量",
    "Recycledquantity": "已回收數量",
    "Totaldepartmentapplications": "科室申請數量總和",
    "Recyclingtime": "回收時間",
    "Demandtime": "需求時間",
    "Oneclickpackaging": "一鍵打包",
    "Dressingbag": "敷料包",
    "registrant": "登記人",
    "singlePot": "單鍋",
    "pleaseSelectAPackage": "請選擇包",
    "sterilizationEquipmentRegistration": "滅菌設備登記",
    "sterilizationEquipment": "滅菌設備",
    "faulty": "有故障",
    "pressureReducingValve": "減壓閥",
    "innerChamberPressure": "內室壓力（0）",
    "interlayerPressure": "夾層壓力（-0.1）",
    "tapWater": "自來水（0.15-0.3MPa）",
    "compressedAir1": "壓縮空氣（0.4-0.7MPa）",
    "exhaustPort": "排氣口",
    "cabinetDoor": "櫃門",
    "wordsize": "字號",
    "Rowheight": "行高",
    "Bold": "粗體",
    "alignment": "對齊",
    "theleft": "左邊",
    "Center": "居中",
    "theright": "右邊",
    "Inversecolor": "反色",
    "remove": "移除",
    "Labelsize": "標籤尺寸",
    "meshsize": "網格尺寸",
    "scaling": "縮放比例",
    "ExitFullScreen": "退出全屏",
    "text": "文本",
    "QRcode": "二維碼",
    "barcode": "條形碼",
    "DMcode": "DM碼",
    "pixelsize": "像素尺寸",
    "Duringfilming": "拍攝中",
    "Multiplefileupload": "多文件上傳",
    "fileupload": "文件上傳",
    "serialNumber": "序號",
    "unqualifiedCleaning": "清洗不合格",
    "uploadPhotos": "上傳照片",
    "earlyEnd": "提前結束",
    "finish": "結束",
    "qualified": "合格",
    "fallbackAll": "全部回退",
    "operatingParameters": "運行參數",
    "pleaseScanTheQualityInspector": "請掃描質檢人",
    "cleaningTime": "清洗時間",
    "selectDateTime": "選擇日期時間",
    "inspectionMethod": "檢查方法",
    "unqualifiedQuantity": "不合格數量",
    "descriptiveText": "描述文字",
    "HandoverSupplyRoom": "交接供應室",
    "continue": "繼續",
    "sterilizationQualityInspection": "滅菌質檢",
    "randomInspectionOfSterilizationQuality": "滅菌質量抽查",
    "unqualified": "不合格",
    "sterilizationStartDate": "滅菌開始日期",
    "monitoringStartDate": "監測開始日期",
    "monitoringEndDate": "監測結束日期",
    "earlyReleaseStatus": "提前放行狀態",
    "biologicalMonitoringResults": "生物監測結果",
    "reasonForEarlyRelease": "提前放行原因",
    "earlyReleaseTime": "提前放行時間",
    "earlyReleaseOfPedestrians": "提前放行人",
    "advanceReleasePackageNotificationTime": "提前放行包通報時間",
    "selectDate": "選擇日期",
    "notifyTheExecutor": "通報執行人",
    "notificationDepartment": "通報科室",
    "released": "已放行",
    "saveEdit": "保存編輯",
    "pleaseScan": "請掃描",
    "first1": "第一",
    "reasonForNonconformity": "不合格原因",
    "submit": "提交",
    "returnTo": "退回至",
    "checkedBy": "抽查人",
    "placementLayer": "擺放層：",
    "placementPosition": "擺放位置",
    "placementMethod": "擺放方式",
    "spotCheckResults": "抽查結果",
    "Totalbeforedisassembly": "拆卸前總數",
    "Totalafterdisassembly": "拆卸後總數",
    "Recyclingremarks": "回收備註",
    "Specialremarks": "特殊備註",
    "Totaldevices": "器械總數",
    "Totalconsumables": "耗材總數",
    "bindingdetails": "綁定明細",
    "CancelScan": "取消掃描",
    "VideoPreview": "視頻預覽",
    "Successfullyidentified": "成功識別",
    "Pieceequipment": "件器械",
    "Pieceexcessequipment": "件多餘器械，請確認",
    "Registrationdevices": "外來器械登記",
    "Receivinginformation": "接收信息",
    "Patientinformation": "病人信息",
    "Patientname": "病人姓名",
    "surgicaldepartment": "手術科室",
    "Affiliatedhospitalarea": "所屬院區",
    "DateOperation": "手術日期",
    "Surgicalname": "手術名稱",
    "deviceinformation": "外來器械信息",
    "taglist": "標籤列表",
    "Bundlelabels": "捆綁標籤",
    "Batchcode": "批次碼",
    "Supplementarysorting": "補打排序",
    "Totalcodeprinting": "總碼打印",
    "Supplementaryprinting": "包明細補打",
    "Labelmodification": "標籤信息修改",
    "sterilizationtime": "滅菌時間",
    "perioddays": "實際計算效期為天數",
    "Packager": "包裝人",
    "Matchingperson": "組配人",
    "Sterilizer": "滅菌人",
    "supplementaryprinting": "補打原因",
    "makesomeone": "補打人",
    "Bundlelabelcode": "捆綁標籤碼",
    "DeleteArchive": "刪除歸檔",
    "consumptionagency": "院內代消",
    "OutsourcedAgency": "院外代消",
    "Deliverer": "送物人",
    "HideFilterItems": "隱藏篩選項",
    "ShowFilterItems": "顯示篩選項",
    "Recyclingdepartmentcategory": "回收科室類別",
    "Classes": "包類別",
    "DirectCost": "直接成本核算",
    "Cleaningqualitytime": "清洗質檢時間",
    "Othercourtyarditems": "其他院區物品",
    "SelectPrintAll": "全選打印",
    "Selectcombinations": "全選組配",
    "BatchPrintList": "批量打印清單",
    "Printbasketlist": "籃筐清單打印",
    "StagingList": "暫存列表",
    "DressingPackageView": "敷料包查看",
    "Completionassembly": "組配完成",
    "PrintRecord": "標籤打印記錄",
    "Documentprinting": "單據打印",
    "printlist": "打印清單",
    "releasedInAdvance": "已提前放行",
    "notReleasedInAdvance": "未提前放行",
    "unregisteredResults": "未登記結果",
    "kilogram": "千克",
    "endOfSterilization": "滅菌結束",
    "toBePackaged": "待包裝",
    "spotCheckTime": "抽查時間",
    "documentProperties": "單據屬性",
    "packageProperties": "包屬性",
    "handleImmediately": "馬上處理",
    "talkLater": "稍後再說",
    "unplannedDistribution": "計劃外發放",
    "scanCode": "掃碼",
    "inputCode": "輸入碼",
    "addToPlanList": "加入到計劃列表",
    "distributionAndPreservation": "發放保存",
    "distributionRecords": "發放記錄",
    "mergePrinting": "合併打印",
    "distributionStatisticsPrinting": "發放統計打印",
    "printed": "已打印",
    "departmentType": "科室類型",
    "toBeDistributed": "待發放",
    "scannedCode": "已掃碼",
    "actualRecycling": "實際回收",
    "recyclingBatchCode": "回收批次碼",
    "distributionApplication": "發放申請",
    "auditTime": "審核時間",
    "auditOrderCode": "審核單碼",
    "issuanceOfReviewOrderCode": "發放審核單碼",
    "loanApplication": "借包申請",
    "contain": "包含",
    "justCheck": "只查",
    "packagingBatch": "包裝批次",
    "packagingTime": "包裝時間",
    "packaginBgatchCode": "包裝批次碼",
    "packageType": "包類型",
    "engraveACard": "刻牌",
    "eliminate": "排除",
    "exchange": "兌換",
    "automaticWarehouseInspection": "自動檢庫",
    "distributionCompleted": "發放完成",
    "removePackageCode": "移除包碼",
    "cancelDistribution": "取消發放",
    "packageName": "包名",
    "singleCode": "單碼",
    "operationFailed": "操作失敗",
    "urgentLevel": "加急等級",
    "deliveredBy": "下送人",
    "confirmDistribution": "確認發放",
    "Devicestatistics": "器械統計",
    "packagestatistics": "器械包統計",
    "Personnelstatistics": "人員統計",
    "Consumablestatistics": "耗材統計",
    "Equipmentstatistics": "設備統計",
    "DepartmentStatistics": "科室統計",
    "Supplierstatistics": "供應商統計",
    "Completedrecyclingapplication": "通過回收申請單完成",
    "ExpiredPackage": "過期包",
    "ModifyUrgentLevel": "修改加急級別",
    "Recyclingstatistics": "回收統計",
    "backforeigninstruments": "回洗外來器械",
    "Firstdevice": "首次外來器械",
    "ItemSummaryExport": "物品匯總導出",
    "Cleaningresults": "清洗結果",
    "Belongingdepartment": "歸屬科室",
    "Totalcleaningamount": "清洗總數",
    "departmentPackageCount": "科室包計數",
    "inventoryWarning": "庫存預警",
    "returningInventory": "退庫",
    "itemOutbound": "物品出庫",
    "unqualifiedRegistration": "不合格登記",
    "confirmOutbound": "確認出庫",
    "confirmRegistration": "確認登記",
    "sterileWarehouseReturn": "無菌庫退庫",
    "addToDistributionList": "加入發放列表",
    "operator": "操作人",
    "packageEncoding": "包編碼",
    "warehousingTime": "入庫時間",
    "expirationTime": "過期時間",
    "problemRegistration": "問題登記",
    "inventoryQuantity": "庫存數量",
    "Cleaningprocess": "清洗流程",
    "timeon": "開始時間",
    "EndTime": "結束時間",
    "Sterilizationresults": "滅菌結果",
    "Sterilizationremarks": "滅菌備註",
    "Totalsterilizationcount": "滅菌總數",
    "EquipmentOperationRecordForm": "設備運行記錄表",
    "Distributiondepartment": "發放科室",
    "Distributionmethod": "發放方式",
    "Stockreturn": "退庫",
    "Distributionstatistics": "發放統計",
    "Sterilizationtype": "滅菌類型",
    "Packagingtype": "包裝類型",
    "Itemrecall": "物品召回",
    "doesnotcontain": "不包含",
    "AmountExport": "金額導出",
    "Distributionstatisticsexport": "發放統計導出",
    "DepartmentAmountExport": "科室金額導出",
    "Totalnumberdevices": "器械數量合計",
    "Totalamount": "金額合計",
    "Instrumentpackagetraceability": "器械包追溯",
    "Itemcode": "物品編碼",
    "Sterilizationbatchcode": "滅菌艙次",
    "Classnumber": "批次碼",
    "Biologicalmonitoringpersonnel": "生物監測人",
    "Receptiontime": "接收時間",
    "Operatingtablenumber": "手術台號",
    "Usagetime": "使用時間",
    "Useregistrant": "使用登記人",
    "monthlyreport": "月度報表",
    "annualreport": "年度報表",
    "month": "月份",
    "Includingdevices": "包含外來器械",
    "Onlysearchdevicesnth": "僅查詢外來器械",
    "nosearchdevices": "不查詢外來器械",
    "year": "年份",
    "Summarizeddepartment": "按科室匯總",
    "SummarizePackageName": "按包名匯總",
    "Outsideplan": "計劃外",
    "insideplan": "計劃內",
    "Redemptionpackage": "兌換包",
    "Costanalysisstatistics": "成本分析統計",
    "January": "1月",
    "February": "2月",
    "March": "3月",
    "April": "4月",
    "May": "5月",
    "June": "6月",
    "July": "7月",
    "August": "8月",
    "September": "9月",
    "October": "10月",
    "November": "11月",
    "December": "12月",
    "ManualCleaning": "手工清洗",
    "receiveRecord": "接收記錄",
    "sterileWarehouse": "無菌庫",
    "totalReceived": "接收總數",
    "onTheSameDay": "當天",
    "detailFolding": "明細折疊",
    "expandDetails": "明細展開",
    "receivingDetails": "接收明細",
    "scanCodeReception": "掃碼接收",
    "storageLocation": "存放位置",
    "wetPackageRegistration": "濕包登記",
    "auditAcceptance": "審核接收",
    "receiveAll": "全部接收",
    "summaryView": "匯總查看",
    "errorLog": "錯誤日誌",
    "labelCode": "標籤碼",
    "receivingMethod": "接收方式",
    "supplyRoomReception": "供應室接收",
    "confirmReceipt": "確認接收",
    "theCurrentInventoryIs": "當前入庫是",
    "difference": "差值",
    "scanErrorLog": "掃碼錯誤日誌",
    "scanCodeInputCorrection": "掃碼輸入更正",
    "receivedSuccessfully": "接收成功",
    "questiontype": "問題類型",
    "location": "部位",
    "Sterilizationmodification": "滅菌修改",
    "Secondinspector": "二檢人",
    "anypointtime": "任意時間點",
    "sterilizationtemperature": "滅菌溫度",
    "Sterilizationpressure": "滅菌壓力",
    "Mainloaditems": "主要裝載物品",
    "chemicalmonitoring": "化學監測",
    "Printingrecordssterilization": "滅菌過程打印記錄",
    "Shielddressingbag": "屏蔽敷料包",
    "Shielddevices": "屏蔽外來器械",
    "Totalnumberrooms": "供應室總數",
    "Totalnumberdepartments": "科室總數",
    "EngravedCodeDetails": "刻碼詳情",
    "PackageLocation": "包位置",
    "Locationengravingpackage": "刻碼包位置",
    "Locationengravingpackagecode": "刻碼包位置碼",
    "Engravedcode": "刻碼包碼",
    "TagCode": "標籤碼",
    "TagCoCarvingPackageNamede": "刻碼包名",
    "Useregistrationstartdate": "使用登記開始日期",
    "Useregistrationenddate": "使用登記結束日期",
    "Startdaterecyclingapplication": "回收申請開始日期",
    "Enddaterecyclingapplication": "回收申請結束日期",
    "Actualrecyclingstartdate": "實際回收開始日期",
    "Actualrecyclingenddate": "實際回收結束日期",
    "Recyclingtimeoutpackets": "回收超時包",
    "Recyclingtimeoutpacketreminder": "回收超時包提醒",
    "Workarea": "工作區域",
    "decontaminationarea": "去污區",
    "Packagingarea": "打包區",
    "sterile": "無菌區",
    "JobDetails": "工作明細",
    "reportingperiod": "報告週期",
    "Reportstatisticalcaliber": "報告統計口徑",
    "DepartmentRelations": "科室關係",
    "Statisticalmethods": "統計方式",
    "Flowstatistics": "流水統計",
    "Unqualifiedinspection": "未質檢",
    "Sterilizationstatistics": "滅菌統計",
    "Cleaningstatistics": "清洗統計",
    "Bypackage": "按包",
    "Bynumbertimes": "按次數",
    "Hidesecondaryrecycling": "隱藏二次回收",
    "Nameforeigndevicemanufacturer": "外來器械廠家名稱",
    "fuzzymatching": "模糊匹配",
    "piece": "件",
    "Recyclingcompleted": "回收完成",
    "Sterilizationcompleted": "滅菌完成",
    "Packagingcompleted": "包裝完成",
    "Cleaningcompleted": "清洗完成",
    "patientAge": "病人年齡",
    "patientGender": "病人性別",
    "surgicalTime": "手術時間",
    "cacheInformation": "緩存信息",
    "queryPatientRecords": "查詢病人記錄",
    "operatingRoomItems": "手術間物品",
    "packagingReview": "包裝審核",
    "sterilizationAudit": "滅菌審核",
    "unit": "單位",
    "dateOfBirth": "出生年月",
    "patientDepartment": "病人科室",
    "patientBedNumber": "病人床號",
    "anesthesiaSystemName": "麻醉系統名稱",
    "preface": "台序",
    "operationDoctor": "操作醫生",
    "doctorID": "醫生工號",
    "heavyDrugResistance": "重耐藥性",
    "batchReturnOfInventory": "批量退庫",
    "assignment": "轉讓",
    "patientCode": "病人登記號",
    "before": "早於",
    "diagnosis": "診斷",
    "Sterilizationpotcode": "滅菌鍋次碼",
    "Potproperties": "鍋次性質",
    "BDtesting": "BD測試",
    "Leaktesting": "測漏測試",
    "Physicalmonitoring": "物理監測",
    "Totalnumberbatches": "鍋次總計",
    "Totaloperatingexpenses": "運行費用總計",
    "Totalcostconsumption": "單鍋加消費用總計",
    "order": "次",
    "Nonsinglepot": "非單鍋",
    "Emptypot": "空鍋",
    "Sterilizationworkload": "滅菌工作量",
    "Displaysupplyroomdata": "顯示供應室數據",
    "Displaysterilizationqualifieddata": "僅顯示滅菌合格數據",
    "Cleaningworkload": "清洗工作量",
    "Displayonlyqualifiecleaningdata": "僅顯示清洗合格數據",
    "Cleaningpackageworkload": "清洗包工作量",
    "Distributionvolume": "發放包工作量",
    "Earlyreleasestatistics": "提前放行統計",
    "Packagingworkload": "包裝工作量",
    "PackageClassName": "包類名",
    "Statisticsreturnissues": "退庫問題統計",
    "Reasonproblem": "問題原因",
    "Usagepackagecount": "使用包數統計",
    "Statisticsnumberdevicesused": "使用器械數量統計",
    "applicationTemplate": "申請模版",
    "applyForANewDeviceKit": "申請新器械包",
    "usingDirtyBags": "使用污包",
    "borrowingRecords": "借包記錄",
    "whetherRoReturnThePackage": "是否還包",
    "applicant": "申請人",
    "applicationRecord": "申請記錄",
    "blockIrrelevantItems": "屏蔽無關物品",
    "inconsistentRecyclingApplication": "申請回收不一致",
    "recyclingQuantity": "回收數量",
    "reasonForRejection": "駁回理由",
    "revoke": "撤銷",
    "increaseQuantity": "增加數量",
    "borrowingTime": "借包時間",
    "borrower": "借包人",
    "handWashingPeople": "手洗人",
    "successfullyStaged": "暫存成功",
    "successfullySubmitted": "提交成功",
    "recyclingApplicationRecord": "回收申請記錄",
    "usageType": "使用類型",
    "patientName": "患者名",
    "selfUseRecords": "自用記錄",
    "expiredEntries": "過期記錄",
    "patientRecords": "病人記錄",
    "Allocatedcostaccounting": "分攤成本核算",
    "CostItemSetting": "成本項目設定",
    "costitem": "成本項",
    "DefaultCost": "默認成本(元)",
    "open": "打開",
    "Foundationcoefficient": "基礎係數",
    "count": "計算",
    "Disinfectionbagcategory": "消毒包類別",
    "completedpackages": "完成包數(個)",
    "Convertbasicworkload": "換算基礎工作量",
    "Disinfectionadditionalcosts": "消毒附加成本（元/個）",
    "Costconsumables": "各類低值耗材成本（元/個）",
    "Depreciationpackaging": "各類包裝折舊成本（元/個）",
    "Pricingdisinfectionpackages": "各類消毒包核價（元/個）",
    "Incomedisinfectionpackagepricing": "消毒包核價收入（元）",
    "CostRunchart": "成本趨勢圖",
    "Totalmonthlydisinfectionpackageaudit": "合計月消毒包核價收入（元）",
    "Totalmonthlytotalcost": "合計月總成本（元）",
    "Totalmonthlydisinfection": "合計月消毒包核價收入（元）",
    "disinfectionpackageconsumables": "消毒包耗材成本率",
    "consumableApplication": "耗材申請",
    "isBorrowBagOrNot": "借包",
    "applicationDate": "申請日期",
    "issuedQuantity": "已發放數量",
    "ageUnit": "年齡單位",
    "cancelRecordQuery": "取消記錄查詢",
    "recordExport": "記錄導出",
    "exportTotalItems": "物品合計導出",
    "cancelUse": "取消使用",
    "preoperative": "術前",
    "postoperative": "術後",
    "preoperativeRegistration": "術前登記",
    "postoperativeRegistration": "術後登記",
    "postoperativePreservation": "保存術後",
    "canceledSuccessfully": "取消成功",
    "cancelRecord": "取消記錄",
    "pleaseSelectADate": "請選擇日期",
    "Converttoequipment": "轉為器械",
    "Converttoconsumables": "轉為耗材",
    "departmentFilter": "科室篩選",
    "scanCodeStatus": "掃碼狀態",
    "shieldOtherScanCodePack": "屏蔽其他人掃的包",
    "onselfScanCode": "自己掃的包",
    "targetState": "達標狀態",
    "scanNoQualified": "已掃碼未達標",
    "scanQualified": "已掃碼達標",
    "noScan": "未掃碼",
    "scanCollectStatistics": "掃碼匯總統計",
    "inspectionType": "檢查類型",
    "timeOfOccurrence": "發生時間",
    "monitoringMethod": "監測方式",
    "unqualifiedType": "不合格類型",
    "deviceName1": "器械名稱",
    "deviceType": "器械類型",
    "inspector": "檢驗人",
    "initialInspector": "初檢人",
    "reviewedBy": "複檢人",
    "scheduling": "排班",
    "workingHours": "工作時間",
    "teamLeaderRandomInspection": "組長抽查",
    "nurseSpotCheck": "護士抽查",
    "qualityController": "質控人",
    "qualityInspectionParty": "質檢方",
    "whole": "整體",
    "packOptionUnquality": "包裝材料不合格",
    "packSignUnquality": "包裝標識不合格",
    "packComplete": "包裝完整性",
    "discoverer": "發現方",
    "wetPackageTypes": "濕包類別",
    "reasonForSteriAndSteam": "滅菌器及蒸汽原因",
    "loadCapcity": "裝載容量",
    "loadPlaceMethod": "裝載擺放方法",
    "packElastic": "包裝鬆緊度",
    "coolTime": "冷卻時間",
    "minute": "分鐘",
    "coolPlacePos": "冷卻擺放位置",
    "furnace": "爐",
    "foundPlace": "發現地點",
    "Programselectionerror": "程序選擇錯誤",
    "Sterilizationfailure": "滅菌不合格",
    "Unqualifiedsterilizationloading": "滅菌裝載不合格",
    "DeviceType": "設備類型",
    "goodsAccept": "物品接收",
    "unqualifiedBatch": "不合格批次",
    "packUnqualified": "包裝不合格",
    "SupRegistration": "補登記",
    "issueUnqualified": "無菌發放不合格",
    "wetPackage": "濕包",
    "packRegisterMsg1": "包裝不合格信息登記",
    "second": "秒",
    "hour": "小時",
    "continuation": "續用",
    "workloadStatistic": "工作量統計",
    "beforeCenter": "前者供應室",
    "afterCenter": "後者供應室",
    "statusNode": "流程節點",
    "handleCenterMsg": "該頁面需要至少兩個供應室才可使用",
    "handOverConfig": "自動交接",
    "elementSize": "元素尺寸",
    "elementPos": "元素位置",
    "saveFirst": "請先保存當前信息",
    "handleCenterMsg2": "前者供應室或後者供應室必須有一個是當前供應室",
    "applicationRecordBatchMsg": "當前申請記錄裏有不同批次，會被一起批量修改，是否繼續",
    "newItemRecall": "新增物品召回",
    "recallInitiationDate": "召回啟動日期",
    "sterilizationFailureReportPerson": "滅菌不合格報告人",
    "recallStartDate": "召回開始日期",
    "resultReviewer": "結果復核者",
    "recallCompletionDate": "召回完畢日期",
    "recallDeadline": "召回截止日期",
    "sterilizationBatchCode": "滅菌批次碼",
    "undistributedList": "未發放列表",
    "issuedUnusedList": "已發放未使用列表",
    "issuedAndUsedList": "已發放已使用列表",
    "recalledList": "已召回列表",
    "sterilizationQuery": "滅菌查詢",
    "nonConformanceReporter": "不合格報告人",
    "notRecalled": "未召回",
    "used": "已使用",
    "recallSuccessful": "召回成功",
    "packageHasUsedByPatient": "該包已被病人使用",
    "packageSuccessfullyRecalled": "該包已成功召回",
    "packageNotList": "該包未在列表中",
    "batchReassembly": "批量重新組配",
    "patientSurgicalName": "病人手術名稱",
    "recallResults": "召回結果",
    "reassembleAll": "全部重新組配",
    "patientInfoRegistra": "病人資訊登記",
    "pleaseSelectPackageReassembled": "請選擇要重新組配的包",
    "planningArrangements": "計畫安排",
    "taskArrangement": "任務安排",
    "taskType": "任務類型",
    "maintenanceInspectionType": "維護檢測類型",
    "maintenanceManufacturer": "維保廠商",
    "faultOccurrenceTime": "故障發生時間",
    "reasonDescription": "原因說明",
    "newTask": "新建任務",
    "editTask": "編輯任務",
    "planType": "計畫類型",
    "newPlan": "新建計畫",
    "editPlan": "編輯計畫",
    "deletePlan": "刪除計畫",
    "viewPlan": "查看計畫",
    "viewTaskRecords": "查看任務記錄",
    "nameSupplyRoom": "供應室名稱",
    "cyclePeriod": "迴圈週期",
    "numberCycles": "迴圈次數",
    "taskRecord": "任務記錄",
    "printAll": "全部列印",
    "notStarted": "未開始",
    "start": "開始",
    "completed": "已完成",
    "regularInspections": "定期巡檢",
    "singlePlan": "單次計畫",
    "isSureDelete": "是否確定刪除",
    "notPrintableTasks": "沒有可列印的任務",
    "taskStartTime": "任務開始時間",
    "maintenanceRecords": "維保記錄",
    "cancelTask": "取消任務",
    "planNumber": "計畫編號",
    "taskNumber": "任務編號",
    "faultTime": "故障時間",
    "maintenanceTime": "維保時間",
    "recordMaintenanceResults": "維保結果記錄",
    "sterilizerName": "滅菌器名稱",
    "viewTotalSterilizationItems": "查看滅菌物品合計",
    "viewSterilizationItems": "查看滅菌物品",
    "itemsInsideTheSterilizationRack": "滅菌架內物品",
    "heatNumber": "爐次",
    "decontaminationKitTotalNumber": "消毒包總工數量",
    "decontaminationTotalCost": "消毒總價",
    "dataDictionary": "數據字典",
    "numericalValue": "數值",
    "isCustom": "是否可自定義",
    "isDefaultSelected": "是否默認選中",
    "temperature": "溫度",
    "PSSterilizer": "請選擇滅菌人",
    "Additionelimination": "加消",
    "TendencyChart": "趨勢圖",
    "OutDepartmentCost": "發放科室成本",
    "DisinfectionSetCosts": "消毒包核價單價（元/個）",
    "notPackageSterilizationBatch": "不是該滅菌批次的包碼",
    "Backwashingamount": "回洗金額",
    "referredtoas": "簡稱",
    "website": "網站",
    "businesslicense": "營業執照",
    "businessterm": "營業期",
    "Temporarybidding": "臨時招標",
    "CompanyAddress": "公司地址",
    "Shortcannotbeempty": "簡稱不能為空",
    "Categorycannotbeempty": "類別不能為空",
    "Temporarybiddingcannotbeempty": "臨時招標不能為空",
    "Devicecode": "器械碼",
    "specifics": "詳情",
    "RegistrationDepartment": "登記科室",
    "Usingsurgicaldepartment": "使用手術科室",
    "admissionnumber": "住院號",
    "registrationstatus": "登記狀態",
    "Batchreturn": "批量歸還",
    "Batchlogout": "批量註銷",
    "logoff": "註銷",
    "unregistered": "未登記",
    "registered": "已登記",
    "Pleaseselectrecord": "請選擇記錄",
    "Patientsurgicalinformation": "患者及手術資訊",
    "ReturnInformation": "歸還資訊",
    "Manufacturerhandoverpersonnel": "廠家交接人員",
    "Operatingroompersonnel": "手術室人員",
    "Supplyroompersonnel": "供應室人員",
    "Handovertime": "交接時間",
    "currentpersonnelnotsupplyroom": "當前人員不屬於供應室",
    "Batchcontinuation": "批量續用",
    "Continueddevices": "外來器械續用",
    "Plannedsurgery": "擬施手術",
    "PatientWard": "病人病區",
    "ExportOverview": "匯出總覽",
    "ExportDetails": "匯出明細",
    "bulkedit": "批量編輯",
    "Exportdevicestatistics": "匯出外來器械統計",
    "devicestatistics": "外來器械統計",
    "Cleaningbatch": "清洗批次",
    "Reviewedby": "覆核人",
    "Secondaryrecycler": "二次回收人",
    "Secondaryrecoverytime": "二次回收時間",
    "Secondbackwashtime": "二次回洗時間",
    "Secondarybackwashingequipment": "二次回洗設備",
    "Secondarybackwashprocedure": "二次回洗程式",
    "Secondarybackwashbatch": "二次回洗批次",
    "Secondarybackwashperson": "二次回洗人",
    "Secondarybackwashresults": "二次回洗結果",
    "Cancellationtime": "註銷時間",
    "Cancelledby": "註銷人",
    "Cancellationhandoverperson": "註銷交接人",
    "Returnedby": "歸還人",
    "Returnhandoverperson": "歸還交接人",
    "Returningphotos": "歸還照片",
    "LogoutInformation": "註銷訊息",
    "EditingPatientInformation": "編輯病人訊息",
    "Totalnumberexternaldevices": "外來器械總數",
    "Quantityrecycledafterexpiration": "過期後再被回收數量",
    "Numbernormalbackwashing": "正常返洗的數量",
    "Numberothercancellationreasons": "其他註銷原因數量",
    "Quantitybackwashed": "待回洗數量",
    "Undistributedquantity": "未發放數量",
    "Pleaseselecdeviceedited": "請選擇需要編輯的外來器械",
    "Borrowingreturningrecords": "借還記錄",
    "Totalnumberimplantpackages": "植入物包數合計",
    "Totalnumberimplantedobjects": "植入物件數合計",
    "MenuID": "選單ID",
    "ParentMenu": "父級選單",
    "MenuName": "選單名稱",
    "MenuRouting": "選單路由",
    "Menuicon": "選單圖標",
    "Menuimage": "選單圖片",
    "Menuorder": "選單順序",
    "Whetherbutton": "是否按鈕",
    "DoesPDAdisplay": "PDA是否顯示",
    "Isanexternalchain": "是否外鏈",
    "editMenu": "編輯選單",
    "DoesthePCdisplay": "PC是否顯示",
    "Modifyexpirationremindertime": "修改效期提醒時間",
    "Selfpackageoutboundregistration": "自用包出庫登記",
    "Expiredpackageoutboundregistration": "過期包出庫登記",
    "RecallInformation": "召回訊息",
    "PacketCountQuery": "包計數査詢",
    "Allocateoperatingrooms": "分配手術間",
    "Returningoperatingroom": "手術間退庫",
    "Selfusepackageoutboundrecord": "自用包出庫記錄",
    "ExpiredPackageDeliveryRecord": "過期包出庫記錄",
    "Allocateoperatingroomrecords": "分配手術間記錄",
    "Surgicalroomreturnrecord": "手術間退庫記錄",
    "Transferrecordoperatingroom": "手術間轉讓記錄",
    "Deliverydate": "出庫日期",
    "primary": "原",
    "Patientregistrationnot": "是否病人登記",
    "EnterthetagcodepressEnter": "輸入標籤碼後回車",
    "Remindertimesterilewarehouseexpirationdate": "無菌庫效期提醒時間",
    "Surgicalroomoutboundregistration": "手術間出庫登記",
    "Stockreturnregistration": "退庫登記",
    "Willnotjoinagain": "已經分配給手術間的包，不會再次加入分配",
    "Pleaseregisteroutboundperson": "請登記出庫人",
    "realtimeprocessing": "請注意物品召回訊息，及時處理",
    "Confirmstockreturn": "確認退庫",
    "departmentcodeselected": "當前科室碼不能選中",
    "additionalCharge": "附加費",
    "remark": "備",
    "Packagingstatistics": "包裝統計",
    "mappingAssociation": "映射關聯",
    "deleteMap": "刪除映射",
    "patientsArticles": "病人物品",
    "selectionPatients": "選擇病人",
    "periodhours": "實際計算效期為小時",
    "Assignedby": "分配人",
    "deletedstate": "删除狀態",
    "Notdeleted": "未删除",
    "yesDeleted": "已删除",
    "Devicedetailscannobeempty": "器械明細不能為空",
    "SpecialRemarkcannobeempty": "特殊備註不能為空",
    "showPassword": "顯示密碼",
    "recycleInforMation": "回收信息",
    "recycleRemark": "回收備註",
    "syncCA": "同步CA",
    "toChoose": "待選",
    "functionConfig": "條件配寘",
    "and": "並且",
    "equal": "等於",
    "greaterAndEqual": "大於或等於",
    "lessAndEqual": "小於或等於",
    "fixedValue": "固定值",
    "Othercourtyard": "其他院區",
    "CSSDhandover": "供應室交接",
    "CSSDhandoverItems": "供應室交接物品",
    "Applicationsamount": "申請金額",
    "Actualacceptanceamount": "實際受理金額",
    "ProcessInterruption": "流程中斷",
    "ProcessInterruptionMsg": "勾選的包流程中斷後無法包裝，是否繼續",
    "carrier": "載具",
    "registrationuseagain": "本次使用登記已達到器械最大使用次數，無法再次回收交接使用",
    "download": "下載",
    "noPage": "該頁面無法存取或不存在",
    "reassemble": "重新組配",
    "printTime": "列印時間",
    "labelTemplateName": "標籤範本名稱",
    "packagMaterialName": "包裝材料名稱",
    "printedBy": "打印人",
    "supplementaryPrintDetails": "補打明細",
    "numberLabelsPrinted": "標籤列印數量",
    "exportData": "匯出圖表",
    "numberPrinInstPacks": "列印器械包數量",
    "workloadStaff": "工作人員工作量",
    "reguPrinQuan": "常規列印數量",
    "quanSuppPrin": "補打數量",
    "PSLPR": "標籤補打記錄占比",
    "CDLPQ": "每日標籤列印數量變化",
    "areRequired": "是必填的",
    "tagDesignPreview": "標籤設計預覽",
    "tagTemplate": "標籤模板",
    "templateSize": "模板尺寸",
    "tagInfo": "標籤資訊",
    "saveAsTemplate": "儲存為模板",
    "templateAlreadyExist": "目前模板已存在內容，是否覆蓋？",
    "selectSizeFirst": "請先完成可選尺寸配置",
    "printTag": "列印標籤",
    "yearMonthDay": "年月日",
    "hourMinuteSecond": "時分秒",
    "tagShowText": "標籤顯示文字",
    "sterilizeDeadline": "滅菌失效時間",
    "province": "省",
    "city": "市",
    "district": "區",
    "county": "區/縣/地級市",
    "dealerName": "經銷商名稱",
    "dealerRank": "經銷商級別",
    "dealerLeader": "上級經銷商",
    "contactName": "聯繫人名稱",
    "contactPhone": "聯繫人電話",
    "tenantName": "租戶名稱",
    "userName": "用戶姓名",
    "userAccount": "使用者帳號",
    "loginPwd": "登入密碼",
    "confirmPwd": "確認密碼",
    "assignTenant": "租戶分配",
    "assignDepartment": "科室分配",
    "identity": "身分",
    "manageUser": "管理用戶",
    "generalUser": "普通用戶",
    "frozen": "凍結",
    "authorizeMethod": "授權方式",
    "tagNumbers": "標籤數量",
    "addressNotEmpty": "地址不能為空",
    "timeNotEmpty": "時間不能為空",
    "confirmPwdNotEmpty": "確認密碼不能為空",
    "mobileNotEmpty": "手機號碼不能為空",
    "tenantNotEmpty": "租戶不能為空",
    "homePage": "首頁",
    "basicData": "基礎數據",
    "sendToTenant": "發送到租戶",
    "changeTenant": "切換租戶",
    "printWarning": "將消耗可用標籤列印數量，是否繼續操作?",
    "confirmToDisable": "確定禁用嗎？",
    "cannotPrintByDelete": "此標籤模版已停用，無法列印！",
    "downloadApp": "下載App",
    "printerNumber": "印表機編號",
    "notActive": "未啟動",
    "activated": "已啟動",
    "tenant": "租戶",
    "activationTime": "啟動時間",
    "preateNewPrinter": "新建印表機",
    "batchResetTenants": "批量重置租戶",
    "summaryStatistics": "匯總統計",
    "modifyingPrinter": "修改印表機",
    "resetTenant": "重置租戶",
    "validityDeadline": "有效截止日期",
    "manufacturer": "生產廠商",
    "prinNumCannEmpt": "印表機編號不能為空",
    "bluetoothAddress": "藍牙地址",
    "bluetAddrCannEmpty": "藍牙地址不能為空",
    "machinSerNumber": "機器序列號",
    "seriNumCannEmpt": "機器序列號不能為空",
    "activaStati": "啟動統計",
    "byTenant": "按租戶",
    "activationDate": "啟動日期",
    "encodePrinter": "按印表機編碼",
    "datePrinCodeCreation": "印表機編碼創建日期",
    "mainExpiDate": "維保到期日",
    "pleaEnteShipArea": "請輸入發貨區域",
    "pleaEnteValiBlueAddr": "請輸入有效的藍牙地址",
    "onlyPritActiStatRese": "只能重置狀態是已啟動的印表機數據",
    "areSureResetTenant": "是否確認重置租戶",
    "resetSuccessful": "重置成功",
    "onlyPrinDataInacStatDele": "只能刪除狀態是未啟動的印表機數據",
    "isSureDele": "是否確認刪除",
    "onlyInacDataModi": "只能修改未啟動的數據。",
    "verifTenants": "核銷租戶",
    "VerifTime": "核銷時間",
    "codeValue": "碼值",
    "batchVoid": "批量作廢",
    "batchWithdWriteOffs": "批量撤回核銷",
    "writeStati": "核銷統計",
    "modifyQRCode": "修改二維碼",
    "void": "作廢",
    "withVeri": "撤回核銷",
    "numberQRCodes": "二維碼數量",
    "positiveDeviation": "正偏差",
    "verifDate": "核銷日期",
    "sheet": "張",
    "writeOffUsers": "核銷用戶",
    "QRCodePreview": "二維碼預覽",
    "pleaEnteNumQR": "請輸入二維碼數量",
    "pleaEnteNumAbel": "請輸入標籤數量",
    "unprinted": "未列印",
    "verified": "已核銷",
    "printSuccessful": "列印成功",
    "veriInvaDataCannInva": "已核銷或作廢的數據不能作廢",
    "isBatcVoidSeleData": "是否確認批量作廢選中的數據",
    "isVoidData": "是否確認作廢該數據",
    "invalidSuccessfully": "作廢成功",
    "onlyBatchWithdDataWrit": "只能批量撤回已核銷的數據",
    "isBatcRetureSeleData": "是否確認批量撤回選中的核銷數據",
    "isRetureSeleData": "是否確認撤回核銷",
    "onlyRetureSeleData": "只能撤回已核銷的數據",
    "withVeriSucc": "撤回核銷成功",
    "veriInvDataCanotDele": "已核銷或作廢的數據不能刪除",
    "isDeleSeleData": "是否確認刪除選擇的數據",
    "isDeleData": "是否確認該數據刪除",
    "enterUserName": "请输入用户名",
    "enterPwd": "请输入密码",
    "selectCenter": "请选择处理中心",
    "selectDep": "请选择科室",
    "aboutProduct": "产品介绍",
    "systemManage": "系统管理",
    "scanAndDownload": "扫码下载（仅安卓）",
    "downloadPrinterDriver": "下载打印机驱动",
    "faqs": "常见问题",
    "activePrinter": "激活打印机",
    "useCode": "核销",
    "updateLog": "更新日志",
    "activeTip": "请扫描打印机编码和填写机器序列号",
    "printerCode": "打印机编码",
    "enterSerialCode": "请输入机器序列号后四位",
    "plaseScanQr": "请扫描标签二维码",
    "qrCode": "二维码编码",
    "userCenter": "个人中心",
    "name": "姓名",
    "phoneNumber": "手机号",
    "tenantExpire": "租户有效期",
    "tenantAvailableTags": "租户可用标签数量（张）",
    "tenantAvailablePrinters": "租户可用打印机数量（台）",
    "tenantOutDatedPrinters": "租户维保到期打印机数量（台）",
    "useTagRecord": "核销标签码记录",
    "activePrinterRecord": "激活打印机记录",
    "oldPwd": "旧密码",
    "inputOldPwd": "请输入旧密码",
    "newPwd": "新密码",
    "inputNewPwd": "请输入新密码",
    "pleaseConfirmPwd": "请确认密码",
    "printerFiles": "打印机文件",
    "pleaseScanPrinterCode": "请扫描打印机编号",
    "pleaseInputSerialCode": "请输入序列号后四位",
    "activePrinterSuccessfully": "打印机激活成功",
    "hospitalSize": "医院规模",
    "hospitalDepCount": "医院科室数量",
    "packageDealCountByDay": "日均器械包处理数量",
    "tagsPrintByDay": "日均标签数量",
    "hospitalSizeCannotBeNull": "医院规模不能为空",
    "hospitalDepCountCannotBeNull": "医院科室数量不能为空",
    "packageDealCountByDayCannotBeNull": "日均器械包处理数量不能为空",
    "tagsPrintByDayCannotBeNull": "日均标签数量不能为空",
    "announceBySMS": "短信通知",
    "confirmToSendSMS": "确定发送通知短信吗？",
    "jobPosition": "职务",
    "warehouseUser": "仓库用户",
    "pleaseSelectTenant": "请先选择租户",
    "pleaseSelectDataToDel": "请选择需要删除的数据",
    "pleaseSaveAndThenOperate": "请保存后再操作",
    "expirePerDay": "每月有效期",
    "validatyHour": "有效期小时",
    "validatyDay": "有效期天数",
    "pleaseSelectValidatyPeriodToSelect": "请选择要修改的有效期",
    "pleaseSelectDeviceStatus": "请选择设备状态",
    "pleaseSelectSteriMethod": "请选择灭菌方式",
    "pleaseSelectBioFrequency": "请选择生物监测频率",
    "greating": "您好!",
    "welcome": "欢迎来到标签管家！",
    "backToHome": "返回主页",
    "loginByApp": "登录app",
    "guideDoc": "说明文档",
    "contractDealer": "联系经销商",
    "buyFromDealer": "直销采购",
    "guideVideo": "演示视频",
    "printerUseVideo": "打印机安装视频",
    "SH": "上海市",
    "honjoMed": "上海红柚医疗器械有限公司",
    "honjoAddress": "上海市徐汇区钦州北路1188号科汇大厦1701室",
    "honjoTel": "4008938068",
    "changeBrowserAndRetry": "请使用自带浏览器打开当前链接并重试。",
    "checking": "检测中...",
    "onShelf": "上架",
    "offShelf": "下架",
    "locationIsRequired": "缺少位置信息",
    "swiperTitle": "轮播图标题",
    "showLoc": "显示位置",
    "linkAddress": "跳转地址",
    "uploadSizeRequire": "为保证手机端显示效果，请尽量选择500 x 265或等比缩放的图片。",
    "setPublishTime": "预定发布时间",
    "publish": "发布",
    "titleCannotBeNull": "标题不可为空",
    "locCannotBeNull": "位置不可为空",
    "orderCannotBeNull": "排序不可为空",
    "imgCannotBeNull": "图片不可为空",
    "publishTimeCannotBeNull": "发布时间不可为空",
    "announceContent": "公告内容",
    "timeRange": "时间范围",
    "modifyAnnounce": "修改公告",
    "sureToPublishAnnounce": "确定发布通知吗？",
    "publishSuccessfully": "发布成功！",
    "sureToDelAnnounce": "确定下架通知吗？",
    "offShelfSuccessfully": "下架成功！",
    "announcePublishTimeRange": "公告发布时间范围",
    "whetherToPublish": "是否发布",
    "startTimeCannotBeEarlyThanNow": "开始时间不得早于当前时间",
    "pleaseInputAnnounceContent": "请输入公告内容",
    "pleaseSelectTime": "请选择时间",
    "createAnnounce": "新建公告",
    "notPublished": "未发布",
    "publishing": "发布中",
    "publishStopped": "发布停止",
    "publishCompleted": "发布完成",
    "universalUse": "通用",
    "publishedMaintaining": "发版维护",
    "publishedVersion": "发布版本",
    "updatedLogTitle": "更新日志标题",
    "createUpdateLog": "新增更新日志",
    "modifyLog": "修改日志",
    "readLog": "查看日志",
    "publishTime": "发布时间",
    "updateLogContent": "更新日志内容",
    "publishedDataCannotBeDelete": "已经发布过的数据不能被删除",
    "allTenantCount": "全部租户数量",
    "userCount": "用户数量",
    "tenantActivedCount": "租户打印机激活数量",
    "innerPrinterActivedCount": "内部打印机激活数量",
    "statisticTitle1": "按租户统计 - 标签打印统计",
    "statisticTitle2": "标签打印总量日趋势",
    "statisticTitle3": "租户地域分布图",
    "statisticUnit1": "家",
    "tenantType": "租户类型",
    "tenantSize": "租户规模",
    "tenantSizeStatistic": "租户规模(日均处理)",
    "totalTagCount": "标签总数",
    "addTag": "添加标签",
    "publicTagInfo": "公用标签信息",
    "uniqueTagInfo": "唯一标签信息",
    "printCount": "打印数量",
    "pleaseSelectTagTemplate": "请先选择标签模板",
    "processNumber": "流水号",
    "tagIdentifyCode": "标签识别码",
    "typeString": "字符",
    "typeCode128": "一维码",
    "typeDatamatrix": "DM码",
    "actualSize": "实际尺寸",
    "exportChart": "导出图表",
    "printingPlatform": "打印渠道",
    "printOnMobile": "移动端打印",
    "printOnPC": "PC端打印",
    "deviationNumber": "正偏差数量",
    "deviationValidateMsg": "请输入一个不超过10的数字",
    "printDate": "打印日期",
    "generateChart": "生成图表",
    "totalCount": "总计费用（元）",
    "byOutDepartment": "按发放科室",
    "to": "到",
    "summaryByDepartmentCost": "按科室费用汇总",
    "byInstrumentset": "按器械包",
    "summaryByInstrumentsetCost": "按器械包费用汇总",
    "noOutDepartment": "无发放科室",
    "cleaningvehicle": "清洗車",
    "notcleanedsimultaneously": "清洗車、器皿、籃筐器械不能同時清洗",
    "qualifyUserMsg": "請登記滅菌資質的人員",
    "qualifyUserMsg2": "第二次質檢的人員不能和第一次的人相同",
    "programAstrict": "程序限制",
    "staging": "工作臺",
    "Currenttotalreceived": "當前待接收總數",
    "distributedsameday": "當天發放總數",
    "ExpandAll": "全部展開",
    "collapseall": "全部折疊",
    "Rejectionoperation": "拒收操作",
    "IsUsed": "是否使用",
    "IsCancelled": "是否註銷",
    "isReturned": "是否歸還",
    "cancelCause": "註銷原因",
    "receiversMinNumMsg": "清點人數量最少爲",
    "BatchModify": "批量修改",
    "Cleaningrecordmodification": "清洗記錄修改",
    "processPacketCount": "流程中包計數",
    "Interruptornot": "是否中斷",
    "recordingtime": "記錄時間",
    "Collectionrecord": "下收記錄",
    "CollectionDepartment": "下收科室",
    "sterilizationProgramMsg": "個包按設定不能用當前滅菌程序開始，是否繼續",
    "sterilizationProgramMsg2": "個包按設定不能用當前滅菌程序開始",
    "SummaryPackageQuantity": "包數量匯總",
    "Distributioncode": "發放碼",
    "Onlyredemptionpackage": "只查兌換包",
    "Handwashprinting": "手洗列印",
    "Machinewashprinting": "機洗列印",
    "DiscoveryPrescription": "發現方科室",
    "qualityPrescription": "質檢方科室",
    "cleanedNumber": "清洗總件數",
    "qualifiedNumber": "合格總件數",
    "unqualifiedNumber": "不合格總件數",
    "qualifiedRate": "合格率",
    "PotItem": "同鍋物品",
    "firstCheckUid": "請掃描第一質檢人",
    "secondCheckUid": "請掃描第二質檢人",
    "packagenotfilteringcriteria": "要包唔喺筛选条件中",
    "Aresuretoreceiveall": "确认全部接收吗？",
    "Aresurereview": "确认审核接收吗？",
    "ReceiveTimeoutAlert": "接收超時提醒",
    "Choosingreturnedsterilization": "拣灭菌器系重新上架，唔拣篇退回留灭菌",
    "reshelf": "重新上架",
    "instrumentPackageMsg": "包裝方式處理方式不能爲空",
    "instrumentPackageMsg2": "供應室的包不會自動發放，數值已改爲-1",
    "OnlyRelevantPack": "僅查相關器械包",
    "ManufacturersContactWay": "廠家聯繫方式",
    "checkHasRecycledByCodesMsg1": "該包碼已經回收，是否繼續",
    "checkHasRecycledByCodesMsg2": "該包碼已經回收，不能再次申請",
    "Oneclickreception": "一鍵接收",
    "selectSurgeryInfo": "請選擇手術信息",
    "Synchronizeapplicationamount": "同步申請金額",
    "wantupdateapplicationpackage": "是否更新這個包的新申請費",
    "theme": "主題",
    "sterilestorageMsg": "該包不在滅菌質檢列表中",
    "procedureErrorPlaceholder": "輸入鍋次後回車",
    "Allreturnstoinventory": "全部退庫",
    "packagereturnTwo": "存在已有科室接受記錄的包，是否將包退回？",
    "Recyclingregistrant": "回收登記人",
    "Repackaging": "重新包装",
    "Aresurerepackageit": "确定重新包装吗?",
    "Cleaningreview": "清洗覆核",
    "wanttocontinue": "該包有科室申請回收記錄，删除後需要重新回收，是否繼續",
    "participationPack": "參與包裝",
    "packType": "一檢",
    "packageType2": "二檢",
    "checkType": "三檢",
    "belongdepartment": "歸屬科室不能為空",
    "packInList": "該包已在列表中",
    "SurgicalNumber": "手術單號",
    "version": "迭代版本",
    "display": "顯示內容",
    "processConfiguration": "流程配置",
    "divtConfiguration": "字典配置",
    "processConfigurationName": "流程配置名稱",
    "configurationRemark": "配置描述",
    "processConfigurationID": "流程配置ID值",
    "divtConfigurationName": "字典配置名稱",
    "divtConfigurationType": "字典配置Type值",
    "newIssue": "新發放重構版",
    "scanCodeMode": "掃碼模式",
    "ConfigurationValue": "配置值",
    "typeValue": "類型值",
    "pageDisplay": "頁面顯示",
    "GeneralSerrings": "通用設置",
    "PrintAbout": "打印相關",
    "ScheduledExpirationReminder": "計劃到期提醒",
    "Otherinformation": "其他資訊",
    "Departmentaltransfertime": "轉入科室時間",
    "Departuretransfertime": "轉離科室時間",
    "Departmentalorderprinting": "科室分單列印",
    "Dateandtimeempty": "日期時間不能為空",
    "Recyclingpackagecode": "回收包碼",
    "defaultUrgent": "默認加急",
    "noUrgent": "不加急",
    "Packaginginquirylabel": "包裝査詢用標籤",
    "Statisticalcycle": "統計週期",
    "Statisticalprocess": "统计流程",
    "Statisticalcalculation": "統計流程",
    "Unitpriceamount": "單價金額",
    "Carvingcodepackage": "刻碼包",
    "Byengravingcode": "按刻碼",
    "Bypackagename": "按包名",
    "Bynumberofpackages": "按包數",
    "statisticalsummary": "統計匯總",
    "Bypackagecategory": "按包類別",
    "Bypackageclassname": "按包類名",
    "Accordingtopackagespecifications": "按包規格",
    "Bypackagetype": "按包類型",
    "Groupbypackage": "按包分組",
    "Byinstrumentpackagename": "按器械包名稱",
    "Bydepartment": "按科室",
    "Pleaseselectthesummarytype": "請選擇統計匯總",
    "Exportsuccessful": "匯出成功",
    "Jumptoqueryfiles": "跳轉査詢檔案",
    "cancelLog": "取消发放日志",
    "Inventorysheetprinting": "清點單列印",
    "operationTime": "操作時間",
    "operateComputer": "操作電腦",
    "Biologicalpackageprinting": "生物監測包列印",
    "BDpackageprinting": "BD監測包列印",
    "vesselNumberMsg": "請填寫器皿數量",
    "packagingTimeRequired": "請填寫包裝時間",
    "clearingRemind": "有部分包的回收時間和本次清洗時間矛盾，需要修改回收時間後纔可以補錄",
    "outerNameSelect": "請選擇驗證通過的包名",
    "hiddenInventory": "隱藏庫存數0",
    "Sterilizerperson": "滅菌人",
    "Feedepartment": "收費科室",
    "expiringdate": "失效日期",
    "PatientRegistration": "病人登記",
    "minCostamount": "最小單位成本金額",
    "packageSummary": "包類彙總",
    "releaseSummary": "發放分類彙總",
    "equipmentOperation": "設備運行",
    "washingVessel": "清洗器皿",
    "highLevelWorkload": "高水平工作量",
    "Tobeassembled": "待組配",
    "PrintInformation": "列印資訊",
    "sterilizationManyPack": "上架0個包",
    "sterilizationManyPackMsg": "該列表目前沒有可上架的包",
    "existingdepartment": "請選擇已有的科室",
    "itemdetailsbeempty": "物品明細不能為空",
    "msg2Issue": "無菌庫有",
    "msg3Issue": "件包過期，",
    "msg4Issue": "件包即將過期，",
    "msg5Issue": "是否立刻處理？",
    "Equipmentnumber": "設備編號",
    "Unusedquantity": "未使用數量",
    "sterilizationManyPackMsg2": "本次上架0個包，請確認。",
    "PrintSettings": "列印設定",
    "Packagingtotalcode": "包裝總碼",
    "packagePrintMsg": "該包是刻碼包但缺少刻碼信息，請刪除後重新回收",
    "Unqualifiedcleaningandreturn": "清洗不合格退回",
    "Unqualifiedsterilizationandreturn": "滅菌不合格退回",
    "Packagingreturn": "包裝退回",
    "Notequalto": "不等於",
    "Empty": "為空",
    "Notempty": "不為空",
    "Basicinformationsupplement": "基礎資訊（補充）",
    "Selectatleastonetimerange": "至少選擇一個時間範圍",
    "tardive": "遲發",
    "Unregisteredpatients": "未登記病人",
    "isContinuation": "是否續用",
    "renewCode": "续用包码",
    "Shortesttime": "最短時間",
    "Maximumtime": "最長時間",
    "Maximumtimenotempty": "最長時間不能為空",
    "Shortesttimenotempty": "最短時間不能為空",
    "sterilizingRack": "上滅菌架",
    "InMachineSterilization": "進機滅菌",
    "ChangeSterilizer": "更換滅菌器",
    "MonitorPackagePrinting": "監測包打印",
    "soldOut": "下架",
    "sterilizationMsg": "請選擇滅菌架",
    "ChangeShelf": "更換滅菌架",
    "sterilizationMsg2": "請選擇要下架的包",
    "putaway": "上架",
    "inEquipment": "進機",
    "sterilizationMsg3": "请配置灭菌架",
    "ScanTheShelf": "掃碼上架",
    "ScanOffTheShelf": "掃碼下架",
    "sterilizationMsg4": "請選中滅菌器或者滅菌架",
    "sterilizationMsg5": "請配置滅菌器",
    "BatchMonitoringPrint": "批量監測包打印",
    "allShelfDelete": "整架移除",
    "setTotalCount": "包合計",
    "DeviceSystemCode": "設備系統編碼",
    "IsBindingSterilizer": "是否綁定滅菌架",
    "BindingSterilizer": "綁定滅菌架",
    "Newequipmentpackageoutbound": "新建器械包出庫",
    "Createanewoutboundtask": "新建出庫任務",
    "Outboundtype": "出庫類型",
    "Numbernewpackages": "新建器械包數量",
    "Requestforoutboundquantity": "申請出庫數量",
    "ProgramRemarks": "程序備註",
    "sterilizationMsg6": "请扫选中灭菌器的程序码",
    "Newpackage": "新包",
    "Theoperatingroomcannotbeempty": "手術間不能為空",
    "ConsumerSchool": "消供學園",
    "OfficeAsepticLibrary": "科室無菌庫",
    "scrutineer": "檢查者",
    "RecyclingComparison": "回收使用對比",
    "Addcustomfields": "添加自定義欄位",
    "CustomFieldName": "自定義欄位名稱",
    "CustomFieldValues": "自定義欄位值",
    "GXYDrRgistrationMsg": "病人名稱不一致，不能保存，請修改",
    "SterilizationQualityUser": "滅菌質檢員",
    "scanSterilizationQualityUser": "请扫描灭菌质检员",
    "questiontypeGroup": "問題組",
    "Summaryprinting": "匯總列印",
    "checkEquipment": "设备检测",
    "backWashingRate": "反洗率",
    "outDatedInstrumentsetsCannotBeAssigned": "過期包不能分配手術間",
    "Viewphotos": "查看圖片",
    "cleanStartTime": "清洗開始時間",
    "exportDetail": "明細匯出",
    "infectedInstrumentSetCount": "感染器械包總數量",
    "infectedInstrumentCount": "感染器械總數量",
    "Nopicturesavailable": "無圖片顯示",
    "DepartmentAggregationExport": "科室聚合匯出",
    "Exportconsumablesdetails": "耗材明細匯出",
    "Pleaseselectthedistributiontime": "請選擇發放時間",
    "Totalnumberbasicdatainstruments": "基礎數據器械數量合計",
    "Totalnumberactualprocessinstruments": "實際流程器械數量合計",
    "Externaldeviceprinting": "外來器械列印",
    "warehouseMsg": "不可批量選擇器械包，請單獨登記器械包",
    "equipmentMsg": "不能打印的数据",
    "Recyclingdepartmentgroup": "回收科室組",
    "Batchoperations": "批量操作",
    "totalCostedFee": "總計加消費用",
    "biologicalMonitoringDay": "生物監測天數",
    "biologicalMonitoringMsg": "已超過x天未生物監測",
    "common": "共",
    "Departmentcategory": "科室類別",
    "Packagegrouping": "包分組",
    "addIntoPackaging": "加入包裝代消",
    "Printseparately": "單獨列印",
    "useDeadline": "使用期限",
    "notFilled": "未填寫",
    "haveExpired": "已過期",
    "committed": "已提交",
    "Statisticaldimension": "統計維度",
    "Statisticalsupplyroomequipmentpackage": "統計供應室器械包",
    "StatisticalDataSpecification": "統計資料規範",
    "Basicdata": "基礎數據",
    "Processdata": "流程數據",
    "AddCancelModify": "加消修改",
    "secondIssueRightMsg6": "當前列表包數超過500，請重新篩選後，再登記發放包",
    "isCollection": "默認集採",
    "sterilizedShelvesNumber": "當前滅菌架上架數量",
    "sterilizerMachinesNumber": "當前滅菌器進機數量",
    "area": "區域",
    "handoverRegistration": "交班登記",
    "Totalnumberofdevices": "器械總件數",
    "CleaningHistory": "清洗歷史記錄",
    "collation": "核對",
    "Cleaningmachineparameterverification": "清洗機參數核對",
    "Verifytheresults": "核對結果",
    "Verifier": "核對人",
    "spareBag": "備用包",
    "operationScheduleTime": "手術排臺時間",
    "Urgentmodification": "修改加急",
    "Scanningtime": "掃碼的時間",
    "ReturnPackage": "退回包",
    "successIn": "成功加入",
    "removbasketitem": "是否移除這行物品的籃筐",
    "operationStorage": "出庫器械包提醒",
    "cancelReviewReject": "取消審覈並駁回",
    "recycleTrack": "回收查詢",
    "reasonDeletion": "请选择删除原因",
    "selectreasonDeletion": "請選擇核對人",
    "urgentReason": "加急原因",
    "withdraw": "撤回",
    "Batchrecycling": "批量回收",
    "Withdrawalsuccessful": "撤回成功",
    "Recyclinginprogress": "正在回收",
    "PatientID": "病人id",
    "warehouseMsg1": "請選擇出庫日期再嘗試導出",
    "Cannotexpedite": "無法加急",
    "Thispackageunableexpedited": "該包被設定為無法加急",
    "clearAllCost": "清洗總計費用",
    "packAllCost": "包裝總計費用",
    "sterilizationAllCost": "滅菌總計費用",
    "issueAllCost": "發放總計費用",
    "otherAllCost": "其他總計費用",
    "totalIssue": "總計發放",
    "totalCost": "總計費用",
    "synchronizingInformation": "同步信息",
    "ordernoMsg1": "已經登記過，請勿重複記錄",
    "ordernoMsg2": "已經記錄了廠家、病人、包信息，是否覆蓋？",
    "Longqueueforcleaningmachines": "長龍清洗機排隊",
    "Entrysequence": "進艙順序",
    "Numberofbasketscleaned": "清洗籃筐數",
    "cacheList": "暫存列表",
    "containerCode": "籃筐編碼",
    "cancelStaging": "取消暫存",
    "isCancelStaging": "是否取消暫存",
    "pleaseCancelStaging": "請勾選要取消暫存的項",
    "pleaseCancelStaging1": "請勾選要暫存的項",
    "Settlementreport": "結算報表",
    "Settlementresults": "結算結果",
    "stagingCause": "暫存原因",
    "Theregistrantcannotempty": "登記人不能為空",
    "Theoperatingroomcannotempty": "手術間不能為空",
    "DistributionDepartmentTeam": "發放科室組",
    "cameraID": "摄像头ID",
    "cameraLabel": "摄像头名称",
    "forFaceIdentificationLogin": "人脸识别登录",
    "Lowtemperaturesterilizationcost": "低溫滅菌費用",
    "Lowtemperaturesterilizationcostcalculation": "低溫滅菌費用計算",
    "Calculatesterilizationcost": "計算滅菌費用",
    "Wholepotsterilizationcost": "整鍋滅菌費用(元)",
    "faceIdentificationCameraNotExist": "目前記錄的用於人臉辨識的攝影機不存在，請重新設置",
    "Costallocationaccountingsterilizationequipment": "滅菌設備分攤成本核算",
    "Facialdatabase": "人臉庫",
    "Activatefacialrecognition": "啟動人臉識別",
    "Searchbydepartment": "按科室査詢",
    "Searchbysterilizationbatchnumber": "按滅菌批次號査詢",
    "Sterilizationsharingtotalcost": "滅菌分攤總成本",
    "secondIssueRightMsg7": "無菌庫存在未發放完成的器械包，是否跳轉處理",
    "weightReason": "稱重異常原因",
    "weightAbnormalMsg": "稱重異常，請選擇原因",
    "Selectprogramagain": "選中滅菌器，請再次掃描選中程式",
    "Programselectionsuccessful": "程式選擇成功",
    "sterilizationIssuedMsg": "本次滅菌已發放完畢",
    "scanCodeCheck": "掃碼勾選",
    "scanCancellation": "掃碼取消",
    "Samenamepackageaggregationsorting": "同名包聚合排序",
    "nonconformingPart": "不合格部位",
    "engravingRestoration": "刻碼修復",
    "restoration": "修復",
    "recycleMsg": "會讓這個包恢復到可以回收的狀態，是否繼續",
    "vesselNumberMsg2": "請選擇器皿",
    "actualWeight": "實際重量",
    "designWeight": "設計重量",
    "checkedPack": "已勾選",
    "classifier": "分類人",
    "foreignInstrumentsUsed": "外來器械常用",
    "qualitySupplementRegistration": "质控补登记",
    "equipmentRegistration": "設備登記",
    "operatorSelection": "請選擇操作人",
    "Surgerycompleted": "手術結束",
    "searchitemsbatch": "是否査詢同批次回收的物品",
    "Usagesituation": "使用情况",
    "transferredpatientrecordcontinue": "包會轉移到當前病人記錄，是否繼續",
    "endsurgery": "確認結束手術嗎？",
    "Bydate": "按日期",
    "uniLogin": "單一登入",
    "Maximumpackaginglimit": "包裝最大數限制",
    "Whetherregistration": "是否使用登記",
    "Querywarehousedepartment": "科室無菌庫査詢",
    "sterilizationStartTime": "滅菌開始時間",
    "Pleaseuploadagain": "請重新上傳",
    "Packagingsplit": "包裝折開",
    "BatchSplitting": "批量拆分",
    "instrumentPackageMsg3": "拆分後該包流程終止",
    "cleaningBagAssembly": "潔包組配",
    "packagePrintMsg2": "没有可拆分的包",
    "cleaningInspector": "清洗質檢人",
    "sweepCoding": "掃描編碼",
    "Temperaturepressurenumber": "溫壓儀編號",
    "Temperaturepressurerecord": "溫壓儀記錄",
    "questionContent": "問題內容",
    "descriptionContent": "說明內容",
    "readed": "已讀",
    "unRead": "未讀",
    "markAllAsReaded": "全部標記為已讀",
    "whetherMarkAllAsReaded": "是否全部標記為已讀？",
    "china": '中国',
    "malaysia": "马来西亚",
    "country": "国家",
    "systemName": "红柚“安易溯”标签管家",
    "tenantState": "租户状态",
    "contractType": "合同類型",
    "official": "正式",
    "trial": "試用",
    "contractNumber": "合同編號",
    "contractNumberFormatError": "合同編號格式錯誤",
    "contractNumberCannotBeNull": "合同編號不能爲空",
    "userType": "用戶類型",
    "dealerUser": "經銷商用戶",
    "tenantUser": "租戶用戶",
    "assignDealer": "經銷商分配",
    "emailAddress": "電子郵件地阯",
    "dealerNotEmpty": "經銷商不能爲空",
    "identityNotEmpty": "身份不能爲空",
    "userTypeNotEmpty": "用戶類型不能為空",
    "emailFormatError": "請填寫正確的電子郵件地址",
    "dataLableNotEmpty": "數據標簽不能爲空",
    "dataKeyValueNotEmpty": "數據鍵值不能爲空",
    "displaySortingNotEmpty": "顯示排序不能爲空",
    "divtNameNotEmpty": "字典名稱不能爲空",
  }
}